export const fullResponse = [
    {
        "id": 23590616,
        "node_id": "MDEwOlJlcG9zaXRvcnkyMzU5MDYxNg==",
        "name": "dse-cookbook",
        "full_name": "target/dse-cookbook",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/dse-cookbook",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/target/dse-cookbook",
        "forks_url": "https://api.github.com/repos/target/dse-cookbook/forks",
        "keys_url": "https://api.github.com/repos/target/dse-cookbook/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/dse-cookbook/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/dse-cookbook/teams",
        "hooks_url": "https://api.github.com/repos/target/dse-cookbook/hooks",
        "issue_events_url": "https://api.github.com/repos/target/dse-cookbook/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/dse-cookbook/events",
        "assignees_url": "https://api.github.com/repos/target/dse-cookbook/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/dse-cookbook/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/dse-cookbook/tags",
        "blobs_url": "https://api.github.com/repos/target/dse-cookbook/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/dse-cookbook/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/dse-cookbook/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/dse-cookbook/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/dse-cookbook/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/dse-cookbook/languages",
        "stargazers_url": "https://api.github.com/repos/target/dse-cookbook/stargazers",
        "contributors_url": "https://api.github.com/repos/target/dse-cookbook/contributors",
        "subscribers_url": "https://api.github.com/repos/target/dse-cookbook/subscribers",
        "subscription_url": "https://api.github.com/repos/target/dse-cookbook/subscription",
        "commits_url": "https://api.github.com/repos/target/dse-cookbook/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/dse-cookbook/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/dse-cookbook/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/dse-cookbook/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/dse-cookbook/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/dse-cookbook/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/dse-cookbook/merges",
        "archive_url": "https://api.github.com/repos/target/dse-cookbook/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/dse-cookbook/downloads",
        "issues_url": "https://api.github.com/repos/target/dse-cookbook/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/dse-cookbook/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/dse-cookbook/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/dse-cookbook/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/dse-cookbook/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/dse-cookbook/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/dse-cookbook/deployments",
        "created_at": "2014-09-02T18:33:17Z",
        "updated_at": "2018-12-18T20:43:00Z",
        "pushed_at": "2018-12-18T20:31:51Z",
        "git_url": "git://github.com/target/dse-cookbook.git",
        "ssh_url": "git@github.com:target/dse-cookbook.git",
        "clone_url": "https://github.com/target/dse-cookbook.git",
        "svn_url": "https://github.com/target/dse-cookbook",
        "homepage": "",
        "size": 408,
        "stargazers_count": 37,
        "watchers_count": 37,
        "language": null,
        "has_issues": false,
        "has_projects": false,
        "has_downloads": true,
        "has_wiki": false,
        "has_pages": false,
        "forks_count": 37,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 11,
        "license": null,
        "topics": [],
        "forks": 37,
        "open_issues": 11,
        "watchers": 37,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 25875043,
        "node_id": "MDEwOlJlcG9zaXRvcnkyNTg3NTA0Mw==",
        "name": "javascript",
        "full_name": "target/javascript",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/javascript",
        "description": "JavaScript Style Guide",
        "fork": true,
        "url": "https://api.github.com/repos/target/javascript",
        "forks_url": "https://api.github.com/repos/target/javascript/forks",
        "keys_url": "https://api.github.com/repos/target/javascript/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/javascript/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/javascript/teams",
        "hooks_url": "https://api.github.com/repos/target/javascript/hooks",
        "issue_events_url": "https://api.github.com/repos/target/javascript/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/javascript/events",
        "assignees_url": "https://api.github.com/repos/target/javascript/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/javascript/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/javascript/tags",
        "blobs_url": "https://api.github.com/repos/target/javascript/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/javascript/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/javascript/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/javascript/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/javascript/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/javascript/languages",
        "stargazers_url": "https://api.github.com/repos/target/javascript/stargazers",
        "contributors_url": "https://api.github.com/repos/target/javascript/contributors",
        "subscribers_url": "https://api.github.com/repos/target/javascript/subscribers",
        "subscription_url": "https://api.github.com/repos/target/javascript/subscription",
        "commits_url": "https://api.github.com/repos/target/javascript/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/javascript/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/javascript/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/javascript/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/javascript/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/javascript/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/javascript/merges",
        "archive_url": "https://api.github.com/repos/target/javascript/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/javascript/downloads",
        "issues_url": "https://api.github.com/repos/target/javascript/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/javascript/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/javascript/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/javascript/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/javascript/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/javascript/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/javascript/deployments",
        "created_at": "2014-10-28T15:04:41Z",
        "updated_at": "2018-10-03T01:51:21Z",
        "pushed_at": "2017-10-25T15:12:16Z",
        "git_url": "git://github.com/target/javascript.git",
        "ssh_url": "git@github.com:target/javascript.git",
        "clone_url": "https://github.com/target/javascript.git",
        "svn_url": "https://github.com/target/javascript",
        "homepage": null,
        "size": 463,
        "stargazers_count": 7,
        "watchers_count": 7,
        "language": null,
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 2,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 1,
        "license": null,
        "topics": [],
        "forks": 2,
        "open_issues": 1,
        "watchers": 7,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 28348460,
        "node_id": "MDEwOlJlcG9zaXRvcnkyODM0ODQ2MA==",
        "name": "f5-bigip-cookbook",
        "full_name": "target/f5-bigip-cookbook",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/f5-bigip-cookbook",
        "description": "Chef cookbook for F5 Big IP",
        "fork": false,
        "url": "https://api.github.com/repos/target/f5-bigip-cookbook",
        "forks_url": "https://api.github.com/repos/target/f5-bigip-cookbook/forks",
        "keys_url": "https://api.github.com/repos/target/f5-bigip-cookbook/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/f5-bigip-cookbook/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/f5-bigip-cookbook/teams",
        "hooks_url": "https://api.github.com/repos/target/f5-bigip-cookbook/hooks",
        "issue_events_url": "https://api.github.com/repos/target/f5-bigip-cookbook/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/f5-bigip-cookbook/events",
        "assignees_url": "https://api.github.com/repos/target/f5-bigip-cookbook/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/f5-bigip-cookbook/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/f5-bigip-cookbook/tags",
        "blobs_url": "https://api.github.com/repos/target/f5-bigip-cookbook/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/f5-bigip-cookbook/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/f5-bigip-cookbook/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/f5-bigip-cookbook/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/f5-bigip-cookbook/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/f5-bigip-cookbook/languages",
        "stargazers_url": "https://api.github.com/repos/target/f5-bigip-cookbook/stargazers",
        "contributors_url": "https://api.github.com/repos/target/f5-bigip-cookbook/contributors",
        "subscribers_url": "https://api.github.com/repos/target/f5-bigip-cookbook/subscribers",
        "subscription_url": "https://api.github.com/repos/target/f5-bigip-cookbook/subscription",
        "commits_url": "https://api.github.com/repos/target/f5-bigip-cookbook/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/f5-bigip-cookbook/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/f5-bigip-cookbook/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/f5-bigip-cookbook/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/f5-bigip-cookbook/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/f5-bigip-cookbook/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/f5-bigip-cookbook/merges",
        "archive_url": "https://api.github.com/repos/target/f5-bigip-cookbook/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/f5-bigip-cookbook/downloads",
        "issues_url": "https://api.github.com/repos/target/f5-bigip-cookbook/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/f5-bigip-cookbook/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/f5-bigip-cookbook/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/f5-bigip-cookbook/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/f5-bigip-cookbook/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/f5-bigip-cookbook/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/f5-bigip-cookbook/deployments",
        "created_at": "2014-12-22T16:55:29Z",
        "updated_at": "2018-10-15T13:47:37Z",
        "pushed_at": "2018-10-12T20:41:47Z",
        "git_url": "git://github.com/target/f5-bigip-cookbook.git",
        "ssh_url": "git@github.com:target/f5-bigip-cookbook.git",
        "clone_url": "https://github.com/target/f5-bigip-cookbook.git",
        "svn_url": "https://github.com/target/f5-bigip-cookbook",
        "homepage": "https://supermarket.chef.io/cookbooks/f5-bigip",
        "size": 1783,
        "stargazers_count": 31,
        "watchers_count": 31,
        "language": "Ruby",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 26,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 10,
        "license": {
            "key": "apache-2.0",
            "name": "Apache License 2.0",
            "spdx_id": "Apache-2.0",
            "url": "https://api.github.com/licenses/apache-2.0",
            "node_id": "MDc6TGljZW5zZTI="
        },
        "topics": [],
        "forks": 26,
        "open_issues": 10,
        "watchers": 31,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 32330850,
        "node_id": "MDEwOlJlcG9zaXRvcnkzMjMzMDg1MA==",
        "name": "objective-c-style-guide",
        "full_name": "target/objective-c-style-guide",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/objective-c-style-guide",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/target/objective-c-style-guide",
        "forks_url": "https://api.github.com/repos/target/objective-c-style-guide/forks",
        "keys_url": "https://api.github.com/repos/target/objective-c-style-guide/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/objective-c-style-guide/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/objective-c-style-guide/teams",
        "hooks_url": "https://api.github.com/repos/target/objective-c-style-guide/hooks",
        "issue_events_url": "https://api.github.com/repos/target/objective-c-style-guide/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/objective-c-style-guide/events",
        "assignees_url": "https://api.github.com/repos/target/objective-c-style-guide/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/objective-c-style-guide/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/objective-c-style-guide/tags",
        "blobs_url": "https://api.github.com/repos/target/objective-c-style-guide/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/objective-c-style-guide/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/objective-c-style-guide/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/objective-c-style-guide/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/objective-c-style-guide/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/objective-c-style-guide/languages",
        "stargazers_url": "https://api.github.com/repos/target/objective-c-style-guide/stargazers",
        "contributors_url": "https://api.github.com/repos/target/objective-c-style-guide/contributors",
        "subscribers_url": "https://api.github.com/repos/target/objective-c-style-guide/subscribers",
        "subscription_url": "https://api.github.com/repos/target/objective-c-style-guide/subscription",
        "commits_url": "https://api.github.com/repos/target/objective-c-style-guide/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/objective-c-style-guide/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/objective-c-style-guide/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/objective-c-style-guide/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/objective-c-style-guide/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/objective-c-style-guide/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/objective-c-style-guide/merges",
        "archive_url": "https://api.github.com/repos/target/objective-c-style-guide/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/objective-c-style-guide/downloads",
        "issues_url": "https://api.github.com/repos/target/objective-c-style-guide/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/objective-c-style-guide/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/objective-c-style-guide/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/objective-c-style-guide/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/objective-c-style-guide/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/objective-c-style-guide/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/objective-c-style-guide/deployments",
        "created_at": "2015-03-16T14:32:20Z",
        "updated_at": "2015-03-16T14:32:20Z",
        "pushed_at": "2015-03-16T14:33:20Z",
        "git_url": "git://github.com/target/objective-c-style-guide.git",
        "ssh_url": "git@github.com:target/objective-c-style-guide.git",
        "clone_url": "https://github.com/target/objective-c-style-guide.git",
        "svn_url": "https://github.com/target/objective-c-style-guide",
        "homepage": null,
        "size": 112,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": null,
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": null,
        "topics": [],
        "forks": 1,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 35125926,
        "node_id": "MDEwOlJlcG9zaXRvcnkzNTEyNTkyNg==",
        "name": "network_interfaces_v2-cookbook",
        "full_name": "target/network_interfaces_v2-cookbook",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/network_interfaces_v2-cookbook",
        "description": "Chef cookbook for managing network interfaces on Ubuntu, RHEL and Windows",
        "fork": false,
        "url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook",
        "forks_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/forks",
        "keys_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/teams",
        "hooks_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/hooks",
        "issue_events_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/events",
        "assignees_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/tags",
        "blobs_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/languages",
        "stargazers_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/stargazers",
        "contributors_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/contributors",
        "subscribers_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/subscribers",
        "subscription_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/subscription",
        "commits_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/merges",
        "archive_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/downloads",
        "issues_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/network_interfaces_v2-cookbook/deployments",
        "created_at": "2015-05-05T21:53:28Z",
        "updated_at": "2017-12-19T12:40:08Z",
        "pushed_at": "2017-06-29T14:55:23Z",
        "git_url": "git://github.com/target/network_interfaces_v2-cookbook.git",
        "ssh_url": "git@github.com:target/network_interfaces_v2-cookbook.git",
        "clone_url": "https://github.com/target/network_interfaces_v2-cookbook.git",
        "svn_url": "https://github.com/target/network_interfaces_v2-cookbook",
        "homepage": "https://supermarket.chef.io/cookbooks/network_interfaces_v2",
        "size": 247,
        "stargazers_count": 14,
        "watchers_count": 14,
        "language": "Ruby",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 17,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 10,
        "license": {
            "key": "apache-2.0",
            "name": "Apache License 2.0",
            "spdx_id": "Apache-2.0",
            "url": "https://api.github.com/licenses/apache-2.0",
            "node_id": "MDc6TGljZW5zZTI="
        },
        "topics": [],
        "forks": 17,
        "open_issues": 10,
        "watchers": 14,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 43314249,
        "node_id": "MDEwOlJlcG9zaXRvcnk0MzMxNDI0OQ==",
        "name": "AFNetworking",
        "full_name": "target/AFNetworking",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/AFNetworking",
        "description": "A delightful iOS and OS X networking framework",
        "fork": true,
        "url": "https://api.github.com/repos/target/AFNetworking",
        "forks_url": "https://api.github.com/repos/target/AFNetworking/forks",
        "keys_url": "https://api.github.com/repos/target/AFNetworking/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/AFNetworking/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/AFNetworking/teams",
        "hooks_url": "https://api.github.com/repos/target/AFNetworking/hooks",
        "issue_events_url": "https://api.github.com/repos/target/AFNetworking/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/AFNetworking/events",
        "assignees_url": "https://api.github.com/repos/target/AFNetworking/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/AFNetworking/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/AFNetworking/tags",
        "blobs_url": "https://api.github.com/repos/target/AFNetworking/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/AFNetworking/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/AFNetworking/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/AFNetworking/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/AFNetworking/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/AFNetworking/languages",
        "stargazers_url": "https://api.github.com/repos/target/AFNetworking/stargazers",
        "contributors_url": "https://api.github.com/repos/target/AFNetworking/contributors",
        "subscribers_url": "https://api.github.com/repos/target/AFNetworking/subscribers",
        "subscription_url": "https://api.github.com/repos/target/AFNetworking/subscription",
        "commits_url": "https://api.github.com/repos/target/AFNetworking/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/AFNetworking/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/AFNetworking/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/AFNetworking/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/AFNetworking/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/AFNetworking/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/AFNetworking/merges",
        "archive_url": "https://api.github.com/repos/target/AFNetworking/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/AFNetworking/downloads",
        "issues_url": "https://api.github.com/repos/target/AFNetworking/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/AFNetworking/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/AFNetworking/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/AFNetworking/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/AFNetworking/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/AFNetworking/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/AFNetworking/deployments",
        "created_at": "2015-09-28T16:58:53Z",
        "updated_at": "2016-04-19T19:36:25Z",
        "pushed_at": "2016-08-11T20:34:45Z",
        "git_url": "git://github.com/target/AFNetworking.git",
        "ssh_url": "git@github.com:target/AFNetworking.git",
        "clone_url": "https://github.com/target/AFNetworking.git",
        "svn_url": "https://github.com/target/AFNetworking",
        "homepage": "http://afnetworking.com",
        "size": 4099,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Objective-C",
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [],
        "forks": 1,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 43314264,
        "node_id": "MDEwOlJlcG9zaXRvcnk0MzMxNDI2NA==",
        "name": "iso-8601-date-formatter",
        "full_name": "target/iso-8601-date-formatter",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/iso-8601-date-formatter",
        "description": "A Cocoa NSFormatter subclass to convert dates to and from ISO-8601-formatted strings. Supports calendar, week, and ordinal formats.",
        "fork": true,
        "url": "https://api.github.com/repos/target/iso-8601-date-formatter",
        "forks_url": "https://api.github.com/repos/target/iso-8601-date-formatter/forks",
        "keys_url": "https://api.github.com/repos/target/iso-8601-date-formatter/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/iso-8601-date-formatter/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/iso-8601-date-formatter/teams",
        "hooks_url": "https://api.github.com/repos/target/iso-8601-date-formatter/hooks",
        "issue_events_url": "https://api.github.com/repos/target/iso-8601-date-formatter/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/iso-8601-date-formatter/events",
        "assignees_url": "https://api.github.com/repos/target/iso-8601-date-formatter/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/iso-8601-date-formatter/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/iso-8601-date-formatter/tags",
        "blobs_url": "https://api.github.com/repos/target/iso-8601-date-formatter/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/iso-8601-date-formatter/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/iso-8601-date-formatter/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/iso-8601-date-formatter/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/iso-8601-date-formatter/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/iso-8601-date-formatter/languages",
        "stargazers_url": "https://api.github.com/repos/target/iso-8601-date-formatter/stargazers",
        "contributors_url": "https://api.github.com/repos/target/iso-8601-date-formatter/contributors",
        "subscribers_url": "https://api.github.com/repos/target/iso-8601-date-formatter/subscribers",
        "subscription_url": "https://api.github.com/repos/target/iso-8601-date-formatter/subscription",
        "commits_url": "https://api.github.com/repos/target/iso-8601-date-formatter/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/iso-8601-date-formatter/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/iso-8601-date-formatter/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/iso-8601-date-formatter/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/iso-8601-date-formatter/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/iso-8601-date-formatter/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/iso-8601-date-formatter/merges",
        "archive_url": "https://api.github.com/repos/target/iso-8601-date-formatter/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/iso-8601-date-formatter/downloads",
        "issues_url": "https://api.github.com/repos/target/iso-8601-date-formatter/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/iso-8601-date-formatter/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/iso-8601-date-formatter/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/iso-8601-date-formatter/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/iso-8601-date-formatter/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/iso-8601-date-formatter/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/iso-8601-date-formatter/deployments",
        "created_at": "2015-09-28T16:59:17Z",
        "updated_at": "2016-04-19T19:38:12Z",
        "pushed_at": "2016-03-24T03:46:37Z",
        "git_url": "git://github.com/target/iso-8601-date-formatter.git",
        "ssh_url": "git@github.com:target/iso-8601-date-formatter.git",
        "clone_url": "https://github.com/target/iso-8601-date-formatter.git",
        "svn_url": "https://github.com/target/iso-8601-date-formatter",
        "homepage": "http://boredzo.org/iso8601dateformatter/",
        "size": 259,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Objective-C",
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [],
        "forks": 1,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 43314278,
        "node_id": "MDEwOlJlcG9zaXRvcnk0MzMxNDI3OA==",
        "name": "KVOController",
        "full_name": "target/KVOController",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/KVOController",
        "description": "Simple, modern, thread-safe key-value observing for iOS and OS X.",
        "fork": true,
        "url": "https://api.github.com/repos/target/KVOController",
        "forks_url": "https://api.github.com/repos/target/KVOController/forks",
        "keys_url": "https://api.github.com/repos/target/KVOController/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/KVOController/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/KVOController/teams",
        "hooks_url": "https://api.github.com/repos/target/KVOController/hooks",
        "issue_events_url": "https://api.github.com/repos/target/KVOController/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/KVOController/events",
        "assignees_url": "https://api.github.com/repos/target/KVOController/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/KVOController/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/KVOController/tags",
        "blobs_url": "https://api.github.com/repos/target/KVOController/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/KVOController/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/KVOController/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/KVOController/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/KVOController/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/KVOController/languages",
        "stargazers_url": "https://api.github.com/repos/target/KVOController/stargazers",
        "contributors_url": "https://api.github.com/repos/target/KVOController/contributors",
        "subscribers_url": "https://api.github.com/repos/target/KVOController/subscribers",
        "subscription_url": "https://api.github.com/repos/target/KVOController/subscription",
        "commits_url": "https://api.github.com/repos/target/KVOController/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/KVOController/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/KVOController/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/KVOController/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/KVOController/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/KVOController/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/KVOController/merges",
        "archive_url": "https://api.github.com/repos/target/KVOController/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/KVOController/downloads",
        "issues_url": "https://api.github.com/repos/target/KVOController/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/KVOController/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/KVOController/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/KVOController/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/KVOController/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/KVOController/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/KVOController/deployments",
        "created_at": "2015-09-28T16:59:31Z",
        "updated_at": "2016-04-19T19:36:10Z",
        "pushed_at": "2015-07-29T17:41:29Z",
        "git_url": "git://github.com/target/KVOController.git",
        "ssh_url": "git@github.com:target/KVOController.git",
        "clone_url": "https://github.com/target/KVOController.git",
        "svn_url": "https://github.com/target/KVOController",
        "homepage": "",
        "size": 179,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Objective-C",
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [],
        "forks": 1,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 43314288,
        "node_id": "MDEwOlJlcG9zaXRvcnk0MzMxNDI4OA==",
        "name": "ObjectiveSugar",
        "full_name": "target/ObjectiveSugar",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/ObjectiveSugar",
        "description": "ObjectiveC additions for humans. Ruby style.",
        "fork": true,
        "url": "https://api.github.com/repos/target/ObjectiveSugar",
        "forks_url": "https://api.github.com/repos/target/ObjectiveSugar/forks",
        "keys_url": "https://api.github.com/repos/target/ObjectiveSugar/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/ObjectiveSugar/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/ObjectiveSugar/teams",
        "hooks_url": "https://api.github.com/repos/target/ObjectiveSugar/hooks",
        "issue_events_url": "https://api.github.com/repos/target/ObjectiveSugar/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/ObjectiveSugar/events",
        "assignees_url": "https://api.github.com/repos/target/ObjectiveSugar/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/ObjectiveSugar/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/ObjectiveSugar/tags",
        "blobs_url": "https://api.github.com/repos/target/ObjectiveSugar/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/ObjectiveSugar/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/ObjectiveSugar/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/ObjectiveSugar/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/ObjectiveSugar/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/ObjectiveSugar/languages",
        "stargazers_url": "https://api.github.com/repos/target/ObjectiveSugar/stargazers",
        "contributors_url": "https://api.github.com/repos/target/ObjectiveSugar/contributors",
        "subscribers_url": "https://api.github.com/repos/target/ObjectiveSugar/subscribers",
        "subscription_url": "https://api.github.com/repos/target/ObjectiveSugar/subscription",
        "commits_url": "https://api.github.com/repos/target/ObjectiveSugar/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/ObjectiveSugar/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/ObjectiveSugar/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/ObjectiveSugar/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/ObjectiveSugar/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/ObjectiveSugar/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/ObjectiveSugar/merges",
        "archive_url": "https://api.github.com/repos/target/ObjectiveSugar/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/ObjectiveSugar/downloads",
        "issues_url": "https://api.github.com/repos/target/ObjectiveSugar/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/ObjectiveSugar/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/ObjectiveSugar/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/ObjectiveSugar/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/ObjectiveSugar/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/ObjectiveSugar/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/ObjectiveSugar/deployments",
        "created_at": "2015-09-28T16:59:46Z",
        "updated_at": "2016-04-19T19:35:46Z",
        "pushed_at": "2016-03-24T02:21:40Z",
        "git_url": "git://github.com/target/ObjectiveSugar.git",
        "ssh_url": "git@github.com:target/ObjectiveSugar.git",
        "clone_url": "https://github.com/target/ObjectiveSugar.git",
        "svn_url": "https://github.com/target/ObjectiveSugar",
        "homepage": null,
        "size": 631,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Objective-C",
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [],
        "forks": 1,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 50061743,
        "node_id": "MDEwOlJlcG9zaXRvcnk1MDA2MTc0Mw==",
        "name": "pacemaker-cookbook",
        "full_name": "target/pacemaker-cookbook",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/pacemaker-cookbook",
        "description": "Chef cookbook for managing pacemaker on RHEL",
        "fork": false,
        "url": "https://api.github.com/repos/target/pacemaker-cookbook",
        "forks_url": "https://api.github.com/repos/target/pacemaker-cookbook/forks",
        "keys_url": "https://api.github.com/repos/target/pacemaker-cookbook/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/pacemaker-cookbook/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/pacemaker-cookbook/teams",
        "hooks_url": "https://api.github.com/repos/target/pacemaker-cookbook/hooks",
        "issue_events_url": "https://api.github.com/repos/target/pacemaker-cookbook/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/pacemaker-cookbook/events",
        "assignees_url": "https://api.github.com/repos/target/pacemaker-cookbook/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/pacemaker-cookbook/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/pacemaker-cookbook/tags",
        "blobs_url": "https://api.github.com/repos/target/pacemaker-cookbook/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/pacemaker-cookbook/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/pacemaker-cookbook/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/pacemaker-cookbook/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/pacemaker-cookbook/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/pacemaker-cookbook/languages",
        "stargazers_url": "https://api.github.com/repos/target/pacemaker-cookbook/stargazers",
        "contributors_url": "https://api.github.com/repos/target/pacemaker-cookbook/contributors",
        "subscribers_url": "https://api.github.com/repos/target/pacemaker-cookbook/subscribers",
        "subscription_url": "https://api.github.com/repos/target/pacemaker-cookbook/subscription",
        "commits_url": "https://api.github.com/repos/target/pacemaker-cookbook/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/pacemaker-cookbook/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/pacemaker-cookbook/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/pacemaker-cookbook/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/pacemaker-cookbook/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/pacemaker-cookbook/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/pacemaker-cookbook/merges",
        "archive_url": "https://api.github.com/repos/target/pacemaker-cookbook/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/pacemaker-cookbook/downloads",
        "issues_url": "https://api.github.com/repos/target/pacemaker-cookbook/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/pacemaker-cookbook/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/pacemaker-cookbook/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/pacemaker-cookbook/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/pacemaker-cookbook/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/pacemaker-cookbook/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/pacemaker-cookbook/deployments",
        "created_at": "2016-01-20T21:32:55Z",
        "updated_at": "2016-11-25T00:56:04Z",
        "pushed_at": "2016-05-04T10:55:01Z",
        "git_url": "git://github.com/target/pacemaker-cookbook.git",
        "ssh_url": "git@github.com:target/pacemaker-cookbook.git",
        "clone_url": "https://github.com/target/pacemaker-cookbook.git",
        "svn_url": "https://github.com/target/pacemaker-cookbook",
        "homepage": "https://supermarket.chef.io/cookbooks/pacemaker",
        "size": 28,
        "stargazers_count": 5,
        "watchers_count": 5,
        "language": "Ruby",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 7,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 5,
        "license": {
            "key": "apache-2.0",
            "name": "Apache License 2.0",
            "spdx_id": "Apache-2.0",
            "url": "https://api.github.com/licenses/apache-2.0",
            "node_id": "MDc6TGljZW5zZTI="
        },
        "topics": [],
        "forks": 7,
        "open_issues": 5,
        "watchers": 5,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 50678142,
        "node_id": "MDEwOlJlcG9zaXRvcnk1MDY3ODE0Mg==",
        "name": "lita-hipchat-admin",
        "full_name": "target/lita-hipchat-admin",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/lita-hipchat-admin",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/target/lita-hipchat-admin",
        "forks_url": "https://api.github.com/repos/target/lita-hipchat-admin/forks",
        "keys_url": "https://api.github.com/repos/target/lita-hipchat-admin/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/lita-hipchat-admin/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/lita-hipchat-admin/teams",
        "hooks_url": "https://api.github.com/repos/target/lita-hipchat-admin/hooks",
        "issue_events_url": "https://api.github.com/repos/target/lita-hipchat-admin/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/lita-hipchat-admin/events",
        "assignees_url": "https://api.github.com/repos/target/lita-hipchat-admin/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/lita-hipchat-admin/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/lita-hipchat-admin/tags",
        "blobs_url": "https://api.github.com/repos/target/lita-hipchat-admin/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/lita-hipchat-admin/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/lita-hipchat-admin/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/lita-hipchat-admin/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/lita-hipchat-admin/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/lita-hipchat-admin/languages",
        "stargazers_url": "https://api.github.com/repos/target/lita-hipchat-admin/stargazers",
        "contributors_url": "https://api.github.com/repos/target/lita-hipchat-admin/contributors",
        "subscribers_url": "https://api.github.com/repos/target/lita-hipchat-admin/subscribers",
        "subscription_url": "https://api.github.com/repos/target/lita-hipchat-admin/subscription",
        "commits_url": "https://api.github.com/repos/target/lita-hipchat-admin/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/lita-hipchat-admin/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/lita-hipchat-admin/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/lita-hipchat-admin/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/lita-hipchat-admin/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/lita-hipchat-admin/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/lita-hipchat-admin/merges",
        "archive_url": "https://api.github.com/repos/target/lita-hipchat-admin/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/lita-hipchat-admin/downloads",
        "issues_url": "https://api.github.com/repos/target/lita-hipchat-admin/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/lita-hipchat-admin/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/lita-hipchat-admin/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/lita-hipchat-admin/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/lita-hipchat-admin/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/lita-hipchat-admin/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/lita-hipchat-admin/deployments",
        "created_at": "2016-01-29T17:17:59Z",
        "updated_at": "2018-12-18T20:42:41Z",
        "pushed_at": "2018-12-18T20:33:53Z",
        "git_url": "git://github.com/target/lita-hipchat-admin.git",
        "ssh_url": "git@github.com:target/lita-hipchat-admin.git",
        "clone_url": "https://github.com/target/lita-hipchat-admin.git",
        "svn_url": "https://github.com/target/lita-hipchat-admin",
        "homepage": "",
        "size": 41,
        "stargazers_count": 1,
        "watchers_count": 1,
        "language": null,
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 2,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 2,
        "license": null,
        "topics": [],
        "forks": 2,
        "open_issues": 2,
        "watchers": 1,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 51929093,
        "node_id": "MDEwOlJlcG9zaXRvcnk1MTkyOTA5Mw==",
        "name": "casper-auto-provisioning",
        "full_name": "target/casper-auto-provisioning",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/casper-auto-provisioning",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/target/casper-auto-provisioning",
        "forks_url": "https://api.github.com/repos/target/casper-auto-provisioning/forks",
        "keys_url": "https://api.github.com/repos/target/casper-auto-provisioning/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/casper-auto-provisioning/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/casper-auto-provisioning/teams",
        "hooks_url": "https://api.github.com/repos/target/casper-auto-provisioning/hooks",
        "issue_events_url": "https://api.github.com/repos/target/casper-auto-provisioning/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/casper-auto-provisioning/events",
        "assignees_url": "https://api.github.com/repos/target/casper-auto-provisioning/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/casper-auto-provisioning/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/casper-auto-provisioning/tags",
        "blobs_url": "https://api.github.com/repos/target/casper-auto-provisioning/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/casper-auto-provisioning/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/casper-auto-provisioning/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/casper-auto-provisioning/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/casper-auto-provisioning/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/casper-auto-provisioning/languages",
        "stargazers_url": "https://api.github.com/repos/target/casper-auto-provisioning/stargazers",
        "contributors_url": "https://api.github.com/repos/target/casper-auto-provisioning/contributors",
        "subscribers_url": "https://api.github.com/repos/target/casper-auto-provisioning/subscribers",
        "subscription_url": "https://api.github.com/repos/target/casper-auto-provisioning/subscription",
        "commits_url": "https://api.github.com/repos/target/casper-auto-provisioning/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/casper-auto-provisioning/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/casper-auto-provisioning/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/casper-auto-provisioning/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/casper-auto-provisioning/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/casper-auto-provisioning/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/casper-auto-provisioning/merges",
        "archive_url": "https://api.github.com/repos/target/casper-auto-provisioning/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/casper-auto-provisioning/downloads",
        "issues_url": "https://api.github.com/repos/target/casper-auto-provisioning/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/casper-auto-provisioning/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/casper-auto-provisioning/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/casper-auto-provisioning/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/casper-auto-provisioning/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/casper-auto-provisioning/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/casper-auto-provisioning/deployments",
        "created_at": "2016-02-17T14:39:12Z",
        "updated_at": "2017-12-13T12:20:08Z",
        "pushed_at": "2016-02-17T21:58:32Z",
        "git_url": "git://github.com/target/casper-auto-provisioning.git",
        "ssh_url": "git@github.com:target/casper-auto-provisioning.git",
        "clone_url": "https://github.com/target/casper-auto-provisioning.git",
        "svn_url": "https://github.com/target/casper-auto-provisioning",
        "homepage": null,
        "size": 24,
        "stargazers_count": 12,
        "watchers_count": 12,
        "language": "Shell",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": null,
        "topics": [],
        "forks": 1,
        "open_issues": 0,
        "watchers": 12,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 51929452,
        "node_id": "MDEwOlJlcG9zaXRvcnk1MTkyOTQ1Mg==",
        "name": "osx-edgelab",
        "full_name": "target/osx-edgelab",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/osx-edgelab",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/target/osx-edgelab",
        "forks_url": "https://api.github.com/repos/target/osx-edgelab/forks",
        "keys_url": "https://api.github.com/repos/target/osx-edgelab/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/osx-edgelab/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/osx-edgelab/teams",
        "hooks_url": "https://api.github.com/repos/target/osx-edgelab/hooks",
        "issue_events_url": "https://api.github.com/repos/target/osx-edgelab/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/osx-edgelab/events",
        "assignees_url": "https://api.github.com/repos/target/osx-edgelab/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/osx-edgelab/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/osx-edgelab/tags",
        "blobs_url": "https://api.github.com/repos/target/osx-edgelab/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/osx-edgelab/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/osx-edgelab/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/osx-edgelab/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/osx-edgelab/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/osx-edgelab/languages",
        "stargazers_url": "https://api.github.com/repos/target/osx-edgelab/stargazers",
        "contributors_url": "https://api.github.com/repos/target/osx-edgelab/contributors",
        "subscribers_url": "https://api.github.com/repos/target/osx-edgelab/subscribers",
        "subscription_url": "https://api.github.com/repos/target/osx-edgelab/subscription",
        "commits_url": "https://api.github.com/repos/target/osx-edgelab/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/osx-edgelab/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/osx-edgelab/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/osx-edgelab/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/osx-edgelab/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/osx-edgelab/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/osx-edgelab/merges",
        "archive_url": "https://api.github.com/repos/target/osx-edgelab/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/osx-edgelab/downloads",
        "issues_url": "https://api.github.com/repos/target/osx-edgelab/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/osx-edgelab/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/osx-edgelab/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/osx-edgelab/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/osx-edgelab/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/osx-edgelab/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/osx-edgelab/deployments",
        "created_at": "2016-02-17T14:44:17Z",
        "updated_at": "2016-02-22T00:08:03Z",
        "pushed_at": "2016-02-17T21:08:20Z",
        "git_url": "git://github.com/target/osx-edgelab.git",
        "ssh_url": "git@github.com:target/osx-edgelab.git",
        "clone_url": "https://github.com/target/osx-edgelab.git",
        "svn_url": "https://github.com/target/osx-edgelab",
        "homepage": null,
        "size": 11,
        "stargazers_count": 2,
        "watchers_count": 2,
        "language": "Python",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": null,
        "topics": [],
        "forks": 1,
        "open_issues": 0,
        "watchers": 2,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 54357249,
        "node_id": "MDEwOlJlcG9zaXRvcnk1NDM1NzI0OQ==",
        "name": "Mantle",
        "full_name": "target/Mantle",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/Mantle",
        "description": "Model framework for Cocoa and Cocoa Touch",
        "fork": true,
        "url": "https://api.github.com/repos/target/Mantle",
        "forks_url": "https://api.github.com/repos/target/Mantle/forks",
        "keys_url": "https://api.github.com/repos/target/Mantle/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/Mantle/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/Mantle/teams",
        "hooks_url": "https://api.github.com/repos/target/Mantle/hooks",
        "issue_events_url": "https://api.github.com/repos/target/Mantle/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/Mantle/events",
        "assignees_url": "https://api.github.com/repos/target/Mantle/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/Mantle/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/Mantle/tags",
        "blobs_url": "https://api.github.com/repos/target/Mantle/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/Mantle/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/Mantle/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/Mantle/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/Mantle/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/Mantle/languages",
        "stargazers_url": "https://api.github.com/repos/target/Mantle/stargazers",
        "contributors_url": "https://api.github.com/repos/target/Mantle/contributors",
        "subscribers_url": "https://api.github.com/repos/target/Mantle/subscribers",
        "subscription_url": "https://api.github.com/repos/target/Mantle/subscription",
        "commits_url": "https://api.github.com/repos/target/Mantle/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/Mantle/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/Mantle/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/Mantle/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/Mantle/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/Mantle/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/Mantle/merges",
        "archive_url": "https://api.github.com/repos/target/Mantle/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/Mantle/downloads",
        "issues_url": "https://api.github.com/repos/target/Mantle/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/Mantle/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/Mantle/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/Mantle/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/Mantle/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/Mantle/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/Mantle/deployments",
        "created_at": "2016-03-21T03:30:42Z",
        "updated_at": "2016-03-21T03:30:43Z",
        "pushed_at": "2016-10-14T20:46:13Z",
        "git_url": "git://github.com/target/Mantle.git",
        "ssh_url": "git@github.com:target/Mantle.git",
        "clone_url": "https://github.com/target/Mantle.git",
        "svn_url": "https://github.com/target/Mantle",
        "homepage": "",
        "size": 1442,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Objective-C",
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": false,
        "has_pages": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [],
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 58077547,
        "node_id": "MDEwOlJlcG9zaXRvcnk1ODA3NzU0Nw==",
        "name": "statsd-kafka-backend",
        "full_name": "target/statsd-kafka-backend",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/statsd-kafka-backend",
        "description": "A Statsd backend for sending metrics to Kafka",
        "fork": false,
        "url": "https://api.github.com/repos/target/statsd-kafka-backend",
        "forks_url": "https://api.github.com/repos/target/statsd-kafka-backend/forks",
        "keys_url": "https://api.github.com/repos/target/statsd-kafka-backend/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/statsd-kafka-backend/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/statsd-kafka-backend/teams",
        "hooks_url": "https://api.github.com/repos/target/statsd-kafka-backend/hooks",
        "issue_events_url": "https://api.github.com/repos/target/statsd-kafka-backend/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/statsd-kafka-backend/events",
        "assignees_url": "https://api.github.com/repos/target/statsd-kafka-backend/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/statsd-kafka-backend/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/statsd-kafka-backend/tags",
        "blobs_url": "https://api.github.com/repos/target/statsd-kafka-backend/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/statsd-kafka-backend/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/statsd-kafka-backend/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/statsd-kafka-backend/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/statsd-kafka-backend/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/statsd-kafka-backend/languages",
        "stargazers_url": "https://api.github.com/repos/target/statsd-kafka-backend/stargazers",
        "contributors_url": "https://api.github.com/repos/target/statsd-kafka-backend/contributors",
        "subscribers_url": "https://api.github.com/repos/target/statsd-kafka-backend/subscribers",
        "subscription_url": "https://api.github.com/repos/target/statsd-kafka-backend/subscription",
        "commits_url": "https://api.github.com/repos/target/statsd-kafka-backend/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/statsd-kafka-backend/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/statsd-kafka-backend/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/statsd-kafka-backend/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/statsd-kafka-backend/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/statsd-kafka-backend/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/statsd-kafka-backend/merges",
        "archive_url": "https://api.github.com/repos/target/statsd-kafka-backend/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/statsd-kafka-backend/downloads",
        "issues_url": "https://api.github.com/repos/target/statsd-kafka-backend/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/statsd-kafka-backend/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/statsd-kafka-backend/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/statsd-kafka-backend/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/statsd-kafka-backend/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/statsd-kafka-backend/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/statsd-kafka-backend/deployments",
        "created_at": "2016-05-04T19:10:55Z",
        "updated_at": "2018-10-24T02:46:24Z",
        "pushed_at": "2016-05-26T01:50:45Z",
        "git_url": "git://github.com/target/statsd-kafka-backend.git",
        "ssh_url": "git@github.com:target/statsd-kafka-backend.git",
        "clone_url": "https://github.com/target/statsd-kafka-backend.git",
        "svn_url": "https://github.com/target/statsd-kafka-backend",
        "homepage": "",
        "size": 12,
        "stargazers_count": 15,
        "watchers_count": 15,
        "language": "JavaScript",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 3,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [],
        "forks": 3,
        "open_issues": 0,
        "watchers": 15,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 58946721,
        "node_id": "MDEwOlJlcG9zaXRvcnk1ODk0NjcyMQ==",
        "name": "clouddriver",
        "full_name": "target/clouddriver",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/clouddriver",
        "description": "read and write operations across cloud providers",
        "fork": true,
        "url": "https://api.github.com/repos/target/clouddriver",
        "forks_url": "https://api.github.com/repos/target/clouddriver/forks",
        "keys_url": "https://api.github.com/repos/target/clouddriver/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/clouddriver/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/clouddriver/teams",
        "hooks_url": "https://api.github.com/repos/target/clouddriver/hooks",
        "issue_events_url": "https://api.github.com/repos/target/clouddriver/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/clouddriver/events",
        "assignees_url": "https://api.github.com/repos/target/clouddriver/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/clouddriver/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/clouddriver/tags",
        "blobs_url": "https://api.github.com/repos/target/clouddriver/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/clouddriver/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/clouddriver/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/clouddriver/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/clouddriver/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/clouddriver/languages",
        "stargazers_url": "https://api.github.com/repos/target/clouddriver/stargazers",
        "contributors_url": "https://api.github.com/repos/target/clouddriver/contributors",
        "subscribers_url": "https://api.github.com/repos/target/clouddriver/subscribers",
        "subscription_url": "https://api.github.com/repos/target/clouddriver/subscription",
        "commits_url": "https://api.github.com/repos/target/clouddriver/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/clouddriver/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/clouddriver/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/clouddriver/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/clouddriver/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/clouddriver/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/clouddriver/merges",
        "archive_url": "https://api.github.com/repos/target/clouddriver/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/clouddriver/downloads",
        "issues_url": "https://api.github.com/repos/target/clouddriver/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/clouddriver/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/clouddriver/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/clouddriver/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/clouddriver/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/clouddriver/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/clouddriver/deployments",
        "created_at": "2016-05-16T16:06:08Z",
        "updated_at": "2016-05-16T16:06:14Z",
        "pushed_at": "2016-12-30T17:53:03Z",
        "git_url": "git://github.com/target/clouddriver.git",
        "ssh_url": "git@github.com:target/clouddriver.git",
        "clone_url": "https://github.com/target/clouddriver.git",
        "svn_url": "https://github.com/target/clouddriver",
        "homepage": null,
        "size": 30190,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Groovy",
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": false,
        "has_pages": false,
        "forks_count": 4,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "apache-2.0",
            "name": "Apache License 2.0",
            "spdx_id": "Apache-2.0",
            "url": "https://api.github.com/licenses/apache-2.0",
            "node_id": "MDc6TGljZW5zZTI="
        },
        "topics": [],
        "forks": 4,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 58946837,
        "node_id": "MDEwOlJlcG9zaXRvcnk1ODk0NjgzNw==",
        "name": "deck",
        "full_name": "target/deck",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/deck",
        "description": "Management UI for Spinnaker",
        "fork": true,
        "url": "https://api.github.com/repos/target/deck",
        "forks_url": "https://api.github.com/repos/target/deck/forks",
        "keys_url": "https://api.github.com/repos/target/deck/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/deck/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/deck/teams",
        "hooks_url": "https://api.github.com/repos/target/deck/hooks",
        "issue_events_url": "https://api.github.com/repos/target/deck/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/deck/events",
        "assignees_url": "https://api.github.com/repos/target/deck/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/deck/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/deck/tags",
        "blobs_url": "https://api.github.com/repos/target/deck/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/deck/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/deck/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/deck/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/deck/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/deck/languages",
        "stargazers_url": "https://api.github.com/repos/target/deck/stargazers",
        "contributors_url": "https://api.github.com/repos/target/deck/contributors",
        "subscribers_url": "https://api.github.com/repos/target/deck/subscribers",
        "subscription_url": "https://api.github.com/repos/target/deck/subscription",
        "commits_url": "https://api.github.com/repos/target/deck/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/deck/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/deck/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/deck/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/deck/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/deck/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/deck/merges",
        "archive_url": "https://api.github.com/repos/target/deck/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/deck/downloads",
        "issues_url": "https://api.github.com/repos/target/deck/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/deck/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/deck/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/deck/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/deck/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/deck/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/deck/deployments",
        "created_at": "2016-05-16T16:07:32Z",
        "updated_at": "2016-05-16T16:07:37Z",
        "pushed_at": "2016-11-14T19:20:45Z",
        "git_url": "git://github.com/target/deck.git",
        "ssh_url": "git@github.com:target/deck.git",
        "clone_url": "https://github.com/target/deck.git",
        "svn_url": "https://github.com/target/deck",
        "homepage": "",
        "size": 21320,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "JavaScript",
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "apache-2.0",
            "name": "Apache License 2.0",
            "spdx_id": "Apache-2.0",
            "url": "https://api.github.com/licenses/apache-2.0",
            "node_id": "MDc6TGljZW5zZTI="
        },
        "topics": [],
        "forks": 1,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 58946908,
        "node_id": "MDEwOlJlcG9zaXRvcnk1ODk0NjkwOA==",
        "name": "rosco",
        "full_name": "target/rosco",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/rosco",
        "description": "A bakery for deployable images",
        "fork": true,
        "url": "https://api.github.com/repos/target/rosco",
        "forks_url": "https://api.github.com/repos/target/rosco/forks",
        "keys_url": "https://api.github.com/repos/target/rosco/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/rosco/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/rosco/teams",
        "hooks_url": "https://api.github.com/repos/target/rosco/hooks",
        "issue_events_url": "https://api.github.com/repos/target/rosco/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/rosco/events",
        "assignees_url": "https://api.github.com/repos/target/rosco/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/rosco/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/rosco/tags",
        "blobs_url": "https://api.github.com/repos/target/rosco/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/rosco/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/rosco/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/rosco/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/rosco/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/rosco/languages",
        "stargazers_url": "https://api.github.com/repos/target/rosco/stargazers",
        "contributors_url": "https://api.github.com/repos/target/rosco/contributors",
        "subscribers_url": "https://api.github.com/repos/target/rosco/subscribers",
        "subscription_url": "https://api.github.com/repos/target/rosco/subscription",
        "commits_url": "https://api.github.com/repos/target/rosco/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/rosco/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/rosco/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/rosco/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/rosco/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/rosco/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/rosco/merges",
        "archive_url": "https://api.github.com/repos/target/rosco/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/rosco/downloads",
        "issues_url": "https://api.github.com/repos/target/rosco/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/rosco/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/rosco/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/rosco/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/rosco/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/rosco/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/rosco/deployments",
        "created_at": "2016-05-16T16:08:20Z",
        "updated_at": "2016-05-16T16:08:21Z",
        "pushed_at": "2016-11-16T17:02:47Z",
        "git_url": "git://github.com/target/rosco.git",
        "ssh_url": "git@github.com:target/rosco.git",
        "clone_url": "https://github.com/target/rosco.git",
        "svn_url": "https://github.com/target/rosco",
        "homepage": "",
        "size": 632,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Groovy",
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 1,
        "license": {
            "key": "apache-2.0",
            "name": "Apache License 2.0",
            "spdx_id": "Apache-2.0",
            "url": "https://api.github.com/licenses/apache-2.0",
            "node_id": "MDc6TGljZW5zZTI="
        },
        "topics": [],
        "forks": 0,
        "open_issues": 1,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 59238529,
        "node_id": "MDEwOlJlcG9zaXRvcnk1OTIzODUyOQ==",
        "name": "sccmosd-refresh-multitool",
        "full_name": "target/sccmosd-refresh-multitool",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/sccmosd-refresh-multitool",
        "description": "A method to migrate from Windows 7 (w/ BIOS) to Windows 10 (w/ UEFI) In A Single Task Sequence",
        "fork": false,
        "url": "https://api.github.com/repos/target/sccmosd-refresh-multitool",
        "forks_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/forks",
        "keys_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/teams",
        "hooks_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/hooks",
        "issue_events_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/events",
        "assignees_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/tags",
        "blobs_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/languages",
        "stargazers_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/stargazers",
        "contributors_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/contributors",
        "subscribers_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/subscribers",
        "subscription_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/subscription",
        "commits_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/merges",
        "archive_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/downloads",
        "issues_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/sccmosd-refresh-multitool/deployments",
        "created_at": "2016-05-19T20:01:33Z",
        "updated_at": "2018-11-05T06:46:48Z",
        "pushed_at": "2016-06-22T18:33:50Z",
        "git_url": "git://github.com/target/sccmosd-refresh-multitool.git",
        "ssh_url": "git@github.com:target/sccmosd-refresh-multitool.git",
        "clone_url": "https://github.com/target/sccmosd-refresh-multitool.git",
        "svn_url": "https://github.com/target/sccmosd-refresh-multitool",
        "homepage": "",
        "size": 455,
        "stargazers_count": 8,
        "watchers_count": 8,
        "language": "PowerShell",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 3,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [],
        "forks": 3,
        "open_issues": 0,
        "watchers": 8,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 62238279,
        "node_id": "MDEwOlJlcG9zaXRvcnk2MjIzODI3OQ==",
        "name": "docker-workflow-plugin",
        "full_name": "target/docker-workflow-plugin",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/docker-workflow-plugin",
        "description": null,
        "fork": true,
        "url": "https://api.github.com/repos/target/docker-workflow-plugin",
        "forks_url": "https://api.github.com/repos/target/docker-workflow-plugin/forks",
        "keys_url": "https://api.github.com/repos/target/docker-workflow-plugin/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/docker-workflow-plugin/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/docker-workflow-plugin/teams",
        "hooks_url": "https://api.github.com/repos/target/docker-workflow-plugin/hooks",
        "issue_events_url": "https://api.github.com/repos/target/docker-workflow-plugin/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/docker-workflow-plugin/events",
        "assignees_url": "https://api.github.com/repos/target/docker-workflow-plugin/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/docker-workflow-plugin/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/docker-workflow-plugin/tags",
        "blobs_url": "https://api.github.com/repos/target/docker-workflow-plugin/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/docker-workflow-plugin/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/docker-workflow-plugin/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/docker-workflow-plugin/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/docker-workflow-plugin/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/docker-workflow-plugin/languages",
        "stargazers_url": "https://api.github.com/repos/target/docker-workflow-plugin/stargazers",
        "contributors_url": "https://api.github.com/repos/target/docker-workflow-plugin/contributors",
        "subscribers_url": "https://api.github.com/repos/target/docker-workflow-plugin/subscribers",
        "subscription_url": "https://api.github.com/repos/target/docker-workflow-plugin/subscription",
        "commits_url": "https://api.github.com/repos/target/docker-workflow-plugin/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/docker-workflow-plugin/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/docker-workflow-plugin/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/docker-workflow-plugin/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/docker-workflow-plugin/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/docker-workflow-plugin/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/docker-workflow-plugin/merges",
        "archive_url": "https://api.github.com/repos/target/docker-workflow-plugin/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/docker-workflow-plugin/downloads",
        "issues_url": "https://api.github.com/repos/target/docker-workflow-plugin/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/docker-workflow-plugin/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/docker-workflow-plugin/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/docker-workflow-plugin/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/docker-workflow-plugin/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/docker-workflow-plugin/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/docker-workflow-plugin/deployments",
        "created_at": "2016-06-29T15:46:19Z",
        "updated_at": "2016-06-29T15:46:20Z",
        "pushed_at": "2016-10-09T00:32:33Z",
        "git_url": "git://github.com/target/docker-workflow-plugin.git",
        "ssh_url": "git@github.com:target/docker-workflow-plugin.git",
        "clone_url": "https://github.com/target/docker-workflow-plugin.git",
        "svn_url": "https://github.com/target/docker-workflow-plugin",
        "homepage": "http://wiki.jenkins-ci.org/display/JENKINS/CloudBees+Docker+Pipeline+Plugin",
        "size": 376,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Java",
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": false,
        "has_pages": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [],
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 64501493,
        "node_id": "MDEwOlJlcG9zaXRvcnk2NDUwMTQ5Mw==",
        "name": "cloudpunch",
        "full_name": "target/cloudpunch",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/cloudpunch",
        "description": "A framework to performance test OpenStack at scale",
        "fork": false,
        "url": "https://api.github.com/repos/target/cloudpunch",
        "forks_url": "https://api.github.com/repos/target/cloudpunch/forks",
        "keys_url": "https://api.github.com/repos/target/cloudpunch/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/cloudpunch/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/cloudpunch/teams",
        "hooks_url": "https://api.github.com/repos/target/cloudpunch/hooks",
        "issue_events_url": "https://api.github.com/repos/target/cloudpunch/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/cloudpunch/events",
        "assignees_url": "https://api.github.com/repos/target/cloudpunch/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/cloudpunch/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/cloudpunch/tags",
        "blobs_url": "https://api.github.com/repos/target/cloudpunch/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/cloudpunch/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/cloudpunch/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/cloudpunch/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/cloudpunch/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/cloudpunch/languages",
        "stargazers_url": "https://api.github.com/repos/target/cloudpunch/stargazers",
        "contributors_url": "https://api.github.com/repos/target/cloudpunch/contributors",
        "subscribers_url": "https://api.github.com/repos/target/cloudpunch/subscribers",
        "subscription_url": "https://api.github.com/repos/target/cloudpunch/subscription",
        "commits_url": "https://api.github.com/repos/target/cloudpunch/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/cloudpunch/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/cloudpunch/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/cloudpunch/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/cloudpunch/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/cloudpunch/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/cloudpunch/merges",
        "archive_url": "https://api.github.com/repos/target/cloudpunch/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/cloudpunch/downloads",
        "issues_url": "https://api.github.com/repos/target/cloudpunch/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/cloudpunch/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/cloudpunch/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/cloudpunch/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/cloudpunch/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/cloudpunch/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/cloudpunch/deployments",
        "created_at": "2016-07-29T18:16:55Z",
        "updated_at": "2017-09-28T20:20:31Z",
        "pushed_at": "2018-11-21T15:36:29Z",
        "git_url": "git://github.com/target/cloudpunch.git",
        "ssh_url": "git@github.com:target/cloudpunch.git",
        "clone_url": "https://github.com/target/cloudpunch.git",
        "svn_url": "https://github.com/target/cloudpunch",
        "homepage": null,
        "size": 502,
        "stargazers_count": 4,
        "watchers_count": 4,
        "language": "Python",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 5,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 7,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [
            "openstack"
        ],
        "forks": 5,
        "open_issues": 7,
        "watchers": 4,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 64680211,
        "node_id": "MDEwOlJlcG9zaXRvcnk2NDY4MDIxMQ==",
        "name": "Hygieia",
        "full_name": "target/Hygieia",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/Hygieia",
        "description": "CapitalOne  DevOps Dashboard",
        "fork": true,
        "url": "https://api.github.com/repos/target/Hygieia",
        "forks_url": "https://api.github.com/repos/target/Hygieia/forks",
        "keys_url": "https://api.github.com/repos/target/Hygieia/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/Hygieia/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/Hygieia/teams",
        "hooks_url": "https://api.github.com/repos/target/Hygieia/hooks",
        "issue_events_url": "https://api.github.com/repos/target/Hygieia/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/Hygieia/events",
        "assignees_url": "https://api.github.com/repos/target/Hygieia/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/Hygieia/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/Hygieia/tags",
        "blobs_url": "https://api.github.com/repos/target/Hygieia/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/Hygieia/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/Hygieia/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/Hygieia/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/Hygieia/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/Hygieia/languages",
        "stargazers_url": "https://api.github.com/repos/target/Hygieia/stargazers",
        "contributors_url": "https://api.github.com/repos/target/Hygieia/contributors",
        "subscribers_url": "https://api.github.com/repos/target/Hygieia/subscribers",
        "subscription_url": "https://api.github.com/repos/target/Hygieia/subscription",
        "commits_url": "https://api.github.com/repos/target/Hygieia/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/Hygieia/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/Hygieia/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/Hygieia/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/Hygieia/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/Hygieia/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/Hygieia/merges",
        "archive_url": "https://api.github.com/repos/target/Hygieia/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/Hygieia/downloads",
        "issues_url": "https://api.github.com/repos/target/Hygieia/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/Hygieia/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/Hygieia/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/Hygieia/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/Hygieia/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/Hygieia/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/Hygieia/deployments",
        "created_at": "2016-08-01T15:47:36Z",
        "updated_at": "2018-09-18T14:36:35Z",
        "pushed_at": "2016-12-06T19:35:54Z",
        "git_url": "git://github.com/target/Hygieia.git",
        "ssh_url": "git@github.com:target/Hygieia.git",
        "clone_url": "https://github.com/target/Hygieia.git",
        "svn_url": "https://github.com/target/Hygieia",
        "homepage": "http://www.capitalone.io/Hygieia",
        "size": 60668,
        "stargazers_count": 2,
        "watchers_count": 2,
        "language": "JavaScript",
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 1,
        "license": {
            "key": "apache-2.0",
            "name": "Apache License 2.0",
            "spdx_id": "Apache-2.0",
            "url": "https://api.github.com/licenses/apache-2.0",
            "node_id": "MDc6TGljZW5zZTI="
        },
        "topics": [],
        "forks": 1,
        "open_issues": 1,
        "watchers": 2,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 68241019,
        "node_id": "MDEwOlJlcG9zaXRvcnk2ODI0MTAxOQ==",
        "name": "winnaker",
        "full_name": "target/winnaker",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/winnaker",
        "description": "An audit tool that tests the whole system functionality of Spinnaker",
        "fork": false,
        "url": "https://api.github.com/repos/target/winnaker",
        "forks_url": "https://api.github.com/repos/target/winnaker/forks",
        "keys_url": "https://api.github.com/repos/target/winnaker/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/winnaker/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/winnaker/teams",
        "hooks_url": "https://api.github.com/repos/target/winnaker/hooks",
        "issue_events_url": "https://api.github.com/repos/target/winnaker/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/winnaker/events",
        "assignees_url": "https://api.github.com/repos/target/winnaker/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/winnaker/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/winnaker/tags",
        "blobs_url": "https://api.github.com/repos/target/winnaker/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/winnaker/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/winnaker/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/winnaker/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/winnaker/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/winnaker/languages",
        "stargazers_url": "https://api.github.com/repos/target/winnaker/stargazers",
        "contributors_url": "https://api.github.com/repos/target/winnaker/contributors",
        "subscribers_url": "https://api.github.com/repos/target/winnaker/subscribers",
        "subscription_url": "https://api.github.com/repos/target/winnaker/subscription",
        "commits_url": "https://api.github.com/repos/target/winnaker/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/winnaker/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/winnaker/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/winnaker/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/winnaker/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/winnaker/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/winnaker/merges",
        "archive_url": "https://api.github.com/repos/target/winnaker/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/winnaker/downloads",
        "issues_url": "https://api.github.com/repos/target/winnaker/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/winnaker/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/winnaker/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/winnaker/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/winnaker/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/winnaker/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/winnaker/deployments",
        "created_at": "2016-09-14T20:32:41Z",
        "updated_at": "2018-07-30T01:31:21Z",
        "pushed_at": "2017-11-01T16:57:01Z",
        "git_url": "git://github.com/target/winnaker.git",
        "ssh_url": "git@github.com:target/winnaker.git",
        "clone_url": "https://github.com/target/winnaker.git",
        "svn_url": "https://github.com/target/winnaker",
        "homepage": null,
        "size": 54,
        "stargazers_count": 32,
        "watchers_count": 32,
        "language": "Python",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 13,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 3,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [
            "spinnaker"
        ],
        "forks": 13,
        "open_issues": 3,
        "watchers": 32,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 81456923,
        "node_id": "MDEwOlJlcG9zaXRvcnk4MTQ1NjkyMw==",
        "name": "reuse",
        "full_name": "target/reuse",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/reuse",
        "description": "A simple Golang app to test TCP and SSL/TLS session reuse.",
        "fork": false,
        "url": "https://api.github.com/repos/target/reuse",
        "forks_url": "https://api.github.com/repos/target/reuse/forks",
        "keys_url": "https://api.github.com/repos/target/reuse/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/reuse/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/reuse/teams",
        "hooks_url": "https://api.github.com/repos/target/reuse/hooks",
        "issue_events_url": "https://api.github.com/repos/target/reuse/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/reuse/events",
        "assignees_url": "https://api.github.com/repos/target/reuse/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/reuse/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/reuse/tags",
        "blobs_url": "https://api.github.com/repos/target/reuse/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/reuse/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/reuse/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/reuse/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/reuse/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/reuse/languages",
        "stargazers_url": "https://api.github.com/repos/target/reuse/stargazers",
        "contributors_url": "https://api.github.com/repos/target/reuse/contributors",
        "subscribers_url": "https://api.github.com/repos/target/reuse/subscribers",
        "subscription_url": "https://api.github.com/repos/target/reuse/subscription",
        "commits_url": "https://api.github.com/repos/target/reuse/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/reuse/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/reuse/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/reuse/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/reuse/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/reuse/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/reuse/merges",
        "archive_url": "https://api.github.com/repos/target/reuse/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/reuse/downloads",
        "issues_url": "https://api.github.com/repos/target/reuse/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/reuse/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/reuse/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/reuse/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/reuse/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/reuse/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/reuse/deployments",
        "created_at": "2017-02-09T14:12:56Z",
        "updated_at": "2018-12-07T16:49:40Z",
        "pushed_at": "2018-12-06T13:53:06Z",
        "git_url": "git://github.com/target/reuse.git",
        "ssh_url": "git@github.com:target/reuse.git",
        "clone_url": "https://github.com/target/reuse.git",
        "svn_url": "https://github.com/target/reuse",
        "homepage": "",
        "size": 6,
        "stargazers_count": 5,
        "watchers_count": 5,
        "language": "Go",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 3,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 1,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [],
        "forks": 3,
        "open_issues": 1,
        "watchers": 5,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 81842229,
        "node_id": "MDEwOlJlcG9zaXRvcnk4MTg0MjIyOQ==",
        "name": "pod-reaper",
        "full_name": "target/pod-reaper",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/pod-reaper",
        "description": "Rule based pod killing kubernetes controller",
        "fork": false,
        "url": "https://api.github.com/repos/target/pod-reaper",
        "forks_url": "https://api.github.com/repos/target/pod-reaper/forks",
        "keys_url": "https://api.github.com/repos/target/pod-reaper/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/pod-reaper/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/pod-reaper/teams",
        "hooks_url": "https://api.github.com/repos/target/pod-reaper/hooks",
        "issue_events_url": "https://api.github.com/repos/target/pod-reaper/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/pod-reaper/events",
        "assignees_url": "https://api.github.com/repos/target/pod-reaper/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/pod-reaper/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/pod-reaper/tags",
        "blobs_url": "https://api.github.com/repos/target/pod-reaper/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/pod-reaper/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/pod-reaper/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/pod-reaper/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/pod-reaper/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/pod-reaper/languages",
        "stargazers_url": "https://api.github.com/repos/target/pod-reaper/stargazers",
        "contributors_url": "https://api.github.com/repos/target/pod-reaper/contributors",
        "subscribers_url": "https://api.github.com/repos/target/pod-reaper/subscribers",
        "subscription_url": "https://api.github.com/repos/target/pod-reaper/subscription",
        "commits_url": "https://api.github.com/repos/target/pod-reaper/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/pod-reaper/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/pod-reaper/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/pod-reaper/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/pod-reaper/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/pod-reaper/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/pod-reaper/merges",
        "archive_url": "https://api.github.com/repos/target/pod-reaper/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/pod-reaper/downloads",
        "issues_url": "https://api.github.com/repos/target/pod-reaper/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/pod-reaper/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/pod-reaper/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/pod-reaper/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/pod-reaper/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/pod-reaper/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/pod-reaper/deployments",
        "created_at": "2017-02-13T15:52:15Z",
        "updated_at": "2018-08-13T08:04:40Z",
        "pushed_at": "2017-12-16T23:22:22Z",
        "git_url": "git://github.com/target/pod-reaper.git",
        "ssh_url": "git@github.com:target/pod-reaper.git",
        "clone_url": "https://github.com/target/pod-reaper.git",
        "svn_url": "https://github.com/target/pod-reaper",
        "homepage": "",
        "size": 74,
        "stargazers_count": 18,
        "watchers_count": 18,
        "language": "Go",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 9,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 4,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [
            "chaos",
            "go",
            "kubernetes",
            "resiliency"
        ],
        "forks": 9,
        "open_issues": 4,
        "watchers": 18,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 93182977,
        "node_id": "MDEwOlJlcG9zaXRvcnk5MzE4Mjk3Nw==",
        "name": "jenkins-docker-nginx",
        "full_name": "target/jenkins-docker-nginx",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/jenkins-docker-nginx",
        "description": "Dockerfile for NGINX frontend to Jenkins",
        "fork": false,
        "url": "https://api.github.com/repos/target/jenkins-docker-nginx",
        "forks_url": "https://api.github.com/repos/target/jenkins-docker-nginx/forks",
        "keys_url": "https://api.github.com/repos/target/jenkins-docker-nginx/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/jenkins-docker-nginx/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/jenkins-docker-nginx/teams",
        "hooks_url": "https://api.github.com/repos/target/jenkins-docker-nginx/hooks",
        "issue_events_url": "https://api.github.com/repos/target/jenkins-docker-nginx/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/jenkins-docker-nginx/events",
        "assignees_url": "https://api.github.com/repos/target/jenkins-docker-nginx/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/jenkins-docker-nginx/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/jenkins-docker-nginx/tags",
        "blobs_url": "https://api.github.com/repos/target/jenkins-docker-nginx/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/jenkins-docker-nginx/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/jenkins-docker-nginx/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/jenkins-docker-nginx/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/jenkins-docker-nginx/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/jenkins-docker-nginx/languages",
        "stargazers_url": "https://api.github.com/repos/target/jenkins-docker-nginx/stargazers",
        "contributors_url": "https://api.github.com/repos/target/jenkins-docker-nginx/contributors",
        "subscribers_url": "https://api.github.com/repos/target/jenkins-docker-nginx/subscribers",
        "subscription_url": "https://api.github.com/repos/target/jenkins-docker-nginx/subscription",
        "commits_url": "https://api.github.com/repos/target/jenkins-docker-nginx/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/jenkins-docker-nginx/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/jenkins-docker-nginx/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/jenkins-docker-nginx/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/jenkins-docker-nginx/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/jenkins-docker-nginx/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/jenkins-docker-nginx/merges",
        "archive_url": "https://api.github.com/repos/target/jenkins-docker-nginx/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/jenkins-docker-nginx/downloads",
        "issues_url": "https://api.github.com/repos/target/jenkins-docker-nginx/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/jenkins-docker-nginx/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/jenkins-docker-nginx/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/jenkins-docker-nginx/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/jenkins-docker-nginx/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/jenkins-docker-nginx/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/jenkins-docker-nginx/deployments",
        "created_at": "2017-06-02T16:11:58Z",
        "updated_at": "2018-08-31T14:58:08Z",
        "pushed_at": "2018-04-03T18:25:33Z",
        "git_url": "git://github.com/target/jenkins-docker-nginx.git",
        "ssh_url": "git@github.com:target/jenkins-docker-nginx.git",
        "clone_url": "https://github.com/target/jenkins-docker-nginx.git",
        "svn_url": "https://github.com/target/jenkins-docker-nginx",
        "homepage": "",
        "size": 10,
        "stargazers_count": 6,
        "watchers_count": 6,
        "language": "Shell",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [
            "docker",
            "docker-swarm",
            "jays",
            "jenkins",
            "nginx"
        ],
        "forks": 1,
        "open_issues": 0,
        "watchers": 6,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 93548640,
        "node_id": "MDEwOlJlcG9zaXRvcnk5MzU0ODY0MA==",
        "name": "webinspectapi",
        "full_name": "target/webinspectapi",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/webinspectapi",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/target/webinspectapi",
        "forks_url": "https://api.github.com/repos/target/webinspectapi/forks",
        "keys_url": "https://api.github.com/repos/target/webinspectapi/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/webinspectapi/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/webinspectapi/teams",
        "hooks_url": "https://api.github.com/repos/target/webinspectapi/hooks",
        "issue_events_url": "https://api.github.com/repos/target/webinspectapi/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/webinspectapi/events",
        "assignees_url": "https://api.github.com/repos/target/webinspectapi/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/webinspectapi/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/webinspectapi/tags",
        "blobs_url": "https://api.github.com/repos/target/webinspectapi/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/webinspectapi/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/webinspectapi/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/webinspectapi/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/webinspectapi/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/webinspectapi/languages",
        "stargazers_url": "https://api.github.com/repos/target/webinspectapi/stargazers",
        "contributors_url": "https://api.github.com/repos/target/webinspectapi/contributors",
        "subscribers_url": "https://api.github.com/repos/target/webinspectapi/subscribers",
        "subscription_url": "https://api.github.com/repos/target/webinspectapi/subscription",
        "commits_url": "https://api.github.com/repos/target/webinspectapi/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/webinspectapi/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/webinspectapi/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/webinspectapi/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/webinspectapi/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/webinspectapi/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/webinspectapi/merges",
        "archive_url": "https://api.github.com/repos/target/webinspectapi/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/webinspectapi/downloads",
        "issues_url": "https://api.github.com/repos/target/webinspectapi/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/webinspectapi/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/webinspectapi/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/webinspectapi/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/webinspectapi/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/webinspectapi/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/webinspectapi/deployments",
        "created_at": "2017-06-06T18:06:31Z",
        "updated_at": "2018-12-18T20:41:30Z",
        "pushed_at": "2018-12-18T20:42:22Z",
        "git_url": "git://github.com/target/webinspectapi.git",
        "ssh_url": "git@github.com:target/webinspectapi.git",
        "clone_url": "https://github.com/target/webinspectapi.git",
        "svn_url": "https://github.com/target/webinspectapi",
        "homepage": "",
        "size": 53,
        "stargazers_count": 5,
        "watchers_count": 5,
        "language": null,
        "has_issues": false,
        "has_projects": false,
        "has_downloads": true,
        "has_wiki": false,
        "has_pages": false,
        "forks_count": 5,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": null,
        "topics": [],
        "forks": 5,
        "open_issues": 0,
        "watchers": 5,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 99254518,
        "node_id": "MDEwOlJlcG9zaXRvcnk5OTI1NDUxOA==",
        "name": "webbreaker",
        "full_name": "target/webbreaker",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/webbreaker",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/target/webbreaker",
        "forks_url": "https://api.github.com/repos/target/webbreaker/forks",
        "keys_url": "https://api.github.com/repos/target/webbreaker/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/webbreaker/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/webbreaker/teams",
        "hooks_url": "https://api.github.com/repos/target/webbreaker/hooks",
        "issue_events_url": "https://api.github.com/repos/target/webbreaker/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/webbreaker/events",
        "assignees_url": "https://api.github.com/repos/target/webbreaker/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/webbreaker/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/webbreaker/tags",
        "blobs_url": "https://api.github.com/repos/target/webbreaker/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/webbreaker/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/webbreaker/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/webbreaker/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/webbreaker/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/webbreaker/languages",
        "stargazers_url": "https://api.github.com/repos/target/webbreaker/stargazers",
        "contributors_url": "https://api.github.com/repos/target/webbreaker/contributors",
        "subscribers_url": "https://api.github.com/repos/target/webbreaker/subscribers",
        "subscription_url": "https://api.github.com/repos/target/webbreaker/subscription",
        "commits_url": "https://api.github.com/repos/target/webbreaker/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/webbreaker/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/webbreaker/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/webbreaker/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/webbreaker/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/webbreaker/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/webbreaker/merges",
        "archive_url": "https://api.github.com/repos/target/webbreaker/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/webbreaker/downloads",
        "issues_url": "https://api.github.com/repos/target/webbreaker/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/webbreaker/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/webbreaker/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/webbreaker/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/webbreaker/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/webbreaker/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/webbreaker/deployments",
        "created_at": "2017-08-03T16:41:28Z",
        "updated_at": "2018-12-18T20:44:53Z",
        "pushed_at": "2018-12-14T20:43:16Z",
        "git_url": "git://github.com/target/webbreaker.git",
        "ssh_url": "git@github.com:target/webbreaker.git",
        "clone_url": "https://github.com/target/webbreaker.git",
        "svn_url": "https://github.com/target/webbreaker",
        "homepage": "",
        "size": 1158,
        "stargazers_count": 98,
        "watchers_count": 98,
        "language": null,
        "has_issues": false,
        "has_projects": false,
        "has_downloads": true,
        "has_wiki": false,
        "has_pages": false,
        "forks_count": 37,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 4,
        "license": null,
        "topics": [],
        "forks": 37,
        "open_issues": 4,
        "watchers": 98,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 99954708,
        "node_id": "MDEwOlJlcG9zaXRvcnk5OTk1NDcwOA==",
        "name": "fortifyapi",
        "full_name": "target/fortifyapi",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/fortifyapi",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/target/fortifyapi",
        "forks_url": "https://api.github.com/repos/target/fortifyapi/forks",
        "keys_url": "https://api.github.com/repos/target/fortifyapi/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/fortifyapi/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/fortifyapi/teams",
        "hooks_url": "https://api.github.com/repos/target/fortifyapi/hooks",
        "issue_events_url": "https://api.github.com/repos/target/fortifyapi/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/fortifyapi/events",
        "assignees_url": "https://api.github.com/repos/target/fortifyapi/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/fortifyapi/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/fortifyapi/tags",
        "blobs_url": "https://api.github.com/repos/target/fortifyapi/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/fortifyapi/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/fortifyapi/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/fortifyapi/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/fortifyapi/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/fortifyapi/languages",
        "stargazers_url": "https://api.github.com/repos/target/fortifyapi/stargazers",
        "contributors_url": "https://api.github.com/repos/target/fortifyapi/contributors",
        "subscribers_url": "https://api.github.com/repos/target/fortifyapi/subscribers",
        "subscription_url": "https://api.github.com/repos/target/fortifyapi/subscription",
        "commits_url": "https://api.github.com/repos/target/fortifyapi/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/fortifyapi/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/fortifyapi/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/fortifyapi/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/fortifyapi/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/fortifyapi/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/fortifyapi/merges",
        "archive_url": "https://api.github.com/repos/target/fortifyapi/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/fortifyapi/downloads",
        "issues_url": "https://api.github.com/repos/target/fortifyapi/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/fortifyapi/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/fortifyapi/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/fortifyapi/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/fortifyapi/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/fortifyapi/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/fortifyapi/deployments",
        "created_at": "2017-08-10T18:44:17Z",
        "updated_at": "2018-12-18T20:36:50Z",
        "pushed_at": "2018-12-18T20:44:12Z",
        "git_url": "git://github.com/target/fortifyapi.git",
        "ssh_url": "git@github.com:target/fortifyapi.git",
        "clone_url": "https://github.com/target/fortifyapi.git",
        "svn_url": "https://github.com/target/fortifyapi",
        "homepage": "",
        "size": 44,
        "stargazers_count": 15,
        "watchers_count": 15,
        "language": null,
        "has_issues": false,
        "has_projects": false,
        "has_downloads": true,
        "has_wiki": false,
        "has_pages": false,
        "forks_count": 9,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": null,
        "topics": [],
        "forks": 9,
        "open_issues": 0,
        "watchers": 15,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 102024125,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMDIwMjQxMjU=",
        "name": "jenkins-docker-master",
        "full_name": "target/jenkins-docker-master",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/jenkins-docker-master",
        "description": "Dockerfile for Jenkins master",
        "fork": false,
        "url": "https://api.github.com/repos/target/jenkins-docker-master",
        "forks_url": "https://api.github.com/repos/target/jenkins-docker-master/forks",
        "keys_url": "https://api.github.com/repos/target/jenkins-docker-master/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/jenkins-docker-master/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/jenkins-docker-master/teams",
        "hooks_url": "https://api.github.com/repos/target/jenkins-docker-master/hooks",
        "issue_events_url": "https://api.github.com/repos/target/jenkins-docker-master/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/jenkins-docker-master/events",
        "assignees_url": "https://api.github.com/repos/target/jenkins-docker-master/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/jenkins-docker-master/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/jenkins-docker-master/tags",
        "blobs_url": "https://api.github.com/repos/target/jenkins-docker-master/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/jenkins-docker-master/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/jenkins-docker-master/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/jenkins-docker-master/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/jenkins-docker-master/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/jenkins-docker-master/languages",
        "stargazers_url": "https://api.github.com/repos/target/jenkins-docker-master/stargazers",
        "contributors_url": "https://api.github.com/repos/target/jenkins-docker-master/contributors",
        "subscribers_url": "https://api.github.com/repos/target/jenkins-docker-master/subscribers",
        "subscription_url": "https://api.github.com/repos/target/jenkins-docker-master/subscription",
        "commits_url": "https://api.github.com/repos/target/jenkins-docker-master/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/jenkins-docker-master/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/jenkins-docker-master/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/jenkins-docker-master/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/jenkins-docker-master/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/jenkins-docker-master/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/jenkins-docker-master/merges",
        "archive_url": "https://api.github.com/repos/target/jenkins-docker-master/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/jenkins-docker-master/downloads",
        "issues_url": "https://api.github.com/repos/target/jenkins-docker-master/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/jenkins-docker-master/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/jenkins-docker-master/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/jenkins-docker-master/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/jenkins-docker-master/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/jenkins-docker-master/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/jenkins-docker-master/deployments",
        "created_at": "2017-08-31T16:59:01Z",
        "updated_at": "2018-12-14T21:30:37Z",
        "pushed_at": "2018-12-14T21:31:46Z",
        "git_url": "git://github.com/target/jenkins-docker-master.git",
        "ssh_url": "git@github.com:target/jenkins-docker-master.git",
        "clone_url": "https://github.com/target/jenkins-docker-master.git",
        "svn_url": "https://github.com/target/jenkins-docker-master",
        "homepage": "",
        "size": 42,
        "stargazers_count": 7,
        "watchers_count": 7,
        "language": "Shell",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 3,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [
            "docker",
            "docker-swarm",
            "groovy-scripts",
            "jenkins"
        ],
        "forks": 3,
        "open_issues": 0,
        "watchers": 7,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 102026056,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMDIwMjYwNTY=",
        "name": "grease",
        "full_name": "target/grease",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/grease",
        "description": "Automated Scripting Engine For the Modern Age",
        "fork": false,
        "url": "https://api.github.com/repos/target/grease",
        "forks_url": "https://api.github.com/repos/target/grease/forks",
        "keys_url": "https://api.github.com/repos/target/grease/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/grease/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/grease/teams",
        "hooks_url": "https://api.github.com/repos/target/grease/hooks",
        "issue_events_url": "https://api.github.com/repos/target/grease/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/grease/events",
        "assignees_url": "https://api.github.com/repos/target/grease/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/grease/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/grease/tags",
        "blobs_url": "https://api.github.com/repos/target/grease/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/grease/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/grease/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/grease/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/grease/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/grease/languages",
        "stargazers_url": "https://api.github.com/repos/target/grease/stargazers",
        "contributors_url": "https://api.github.com/repos/target/grease/contributors",
        "subscribers_url": "https://api.github.com/repos/target/grease/subscribers",
        "subscription_url": "https://api.github.com/repos/target/grease/subscription",
        "commits_url": "https://api.github.com/repos/target/grease/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/grease/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/grease/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/grease/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/grease/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/grease/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/grease/merges",
        "archive_url": "https://api.github.com/repos/target/grease/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/grease/downloads",
        "issues_url": "https://api.github.com/repos/target/grease/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/grease/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/grease/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/grease/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/grease/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/grease/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/grease/deployments",
        "created_at": "2017-08-31T17:22:04Z",
        "updated_at": "2018-12-26T01:12:35Z",
        "pushed_at": "2018-12-26T17:35:14Z",
        "git_url": "git://github.com/target/grease.git",
        "ssh_url": "git@github.com:target/grease.git",
        "clone_url": "https://github.com/target/grease.git",
        "svn_url": "https://github.com/target/grease",
        "homepage": "https://grease.readthedocs.io",
        "size": 649,
        "stargazers_count": 24,
        "watchers_count": 24,
        "language": "Python",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 15,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 6,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [
            "automation",
            "engineering",
            "grease",
            "operations",
            "python",
            "python2",
            "python3",
            "scripting",
            "target"
        ],
        "forks": 15,
        "open_issues": 6,
        "watchers": 24,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 105769275,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMDU3NjkyNzU=",
        "name": "coldsalt",
        "full_name": "target/coldsalt",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/coldsalt",
        "description": "API test automation",
        "fork": false,
        "url": "https://api.github.com/repos/target/coldsalt",
        "forks_url": "https://api.github.com/repos/target/coldsalt/forks",
        "keys_url": "https://api.github.com/repos/target/coldsalt/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/coldsalt/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/coldsalt/teams",
        "hooks_url": "https://api.github.com/repos/target/coldsalt/hooks",
        "issue_events_url": "https://api.github.com/repos/target/coldsalt/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/coldsalt/events",
        "assignees_url": "https://api.github.com/repos/target/coldsalt/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/coldsalt/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/coldsalt/tags",
        "blobs_url": "https://api.github.com/repos/target/coldsalt/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/coldsalt/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/coldsalt/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/coldsalt/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/coldsalt/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/coldsalt/languages",
        "stargazers_url": "https://api.github.com/repos/target/coldsalt/stargazers",
        "contributors_url": "https://api.github.com/repos/target/coldsalt/contributors",
        "subscribers_url": "https://api.github.com/repos/target/coldsalt/subscribers",
        "subscription_url": "https://api.github.com/repos/target/coldsalt/subscription",
        "commits_url": "https://api.github.com/repos/target/coldsalt/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/coldsalt/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/coldsalt/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/coldsalt/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/coldsalt/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/coldsalt/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/coldsalt/merges",
        "archive_url": "https://api.github.com/repos/target/coldsalt/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/coldsalt/downloads",
        "issues_url": "https://api.github.com/repos/target/coldsalt/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/coldsalt/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/coldsalt/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/coldsalt/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/coldsalt/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/coldsalt/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/coldsalt/deployments",
        "created_at": "2017-10-04T13:05:45Z",
        "updated_at": "2018-07-13T14:22:49Z",
        "pushed_at": "2018-04-26T13:17:36Z",
        "git_url": "git://github.com/target/coldsalt.git",
        "ssh_url": "git@github.com:target/coldsalt.git",
        "clone_url": "https://github.com/target/coldsalt.git",
        "svn_url": "https://github.com/target/coldsalt",
        "homepage": null,
        "size": 14,
        "stargazers_count": 2,
        "watchers_count": 2,
        "language": "Python",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [],
        "forks": 1,
        "open_issues": 0,
        "watchers": 2,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 105770205,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMDU3NzAyMDU=",
        "name": "boots_of_haste",
        "full_name": "target/boots_of_haste",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/boots_of_haste",
        "description": "This script parses through an Nmap XML file and sends requests through Burp for every open port.",
        "fork": false,
        "url": "https://api.github.com/repos/target/boots_of_haste",
        "forks_url": "https://api.github.com/repos/target/boots_of_haste/forks",
        "keys_url": "https://api.github.com/repos/target/boots_of_haste/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/boots_of_haste/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/boots_of_haste/teams",
        "hooks_url": "https://api.github.com/repos/target/boots_of_haste/hooks",
        "issue_events_url": "https://api.github.com/repos/target/boots_of_haste/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/boots_of_haste/events",
        "assignees_url": "https://api.github.com/repos/target/boots_of_haste/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/boots_of_haste/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/boots_of_haste/tags",
        "blobs_url": "https://api.github.com/repos/target/boots_of_haste/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/boots_of_haste/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/boots_of_haste/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/boots_of_haste/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/boots_of_haste/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/boots_of_haste/languages",
        "stargazers_url": "https://api.github.com/repos/target/boots_of_haste/stargazers",
        "contributors_url": "https://api.github.com/repos/target/boots_of_haste/contributors",
        "subscribers_url": "https://api.github.com/repos/target/boots_of_haste/subscribers",
        "subscription_url": "https://api.github.com/repos/target/boots_of_haste/subscription",
        "commits_url": "https://api.github.com/repos/target/boots_of_haste/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/boots_of_haste/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/boots_of_haste/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/boots_of_haste/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/boots_of_haste/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/boots_of_haste/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/boots_of_haste/merges",
        "archive_url": "https://api.github.com/repos/target/boots_of_haste/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/boots_of_haste/downloads",
        "issues_url": "https://api.github.com/repos/target/boots_of_haste/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/boots_of_haste/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/boots_of_haste/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/boots_of_haste/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/boots_of_haste/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/boots_of_haste/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/boots_of_haste/deployments",
        "created_at": "2017-10-04T13:15:04Z",
        "updated_at": "2018-09-30T01:27:56Z",
        "pushed_at": "2018-09-28T13:30:39Z",
        "git_url": "git://github.com/target/boots_of_haste.git",
        "ssh_url": "git@github.com:target/boots_of_haste.git",
        "clone_url": "https://github.com/target/boots_of_haste.git",
        "svn_url": "https://github.com/target/boots_of_haste",
        "homepage": null,
        "size": 5,
        "stargazers_count": 6,
        "watchers_count": 6,
        "language": "Python",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 3,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 1,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [],
        "forks": 3,
        "open_issues": 1,
        "watchers": 6,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 107565829,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMDc1NjU4Mjk=",
        "name": "graphql-liftoff",
        "full_name": "target/graphql-liftoff",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/graphql-liftoff",
        "description": "Generate GraphQL schema language from API specifications and more",
        "fork": false,
        "url": "https://api.github.com/repos/target/graphql-liftoff",
        "forks_url": "https://api.github.com/repos/target/graphql-liftoff/forks",
        "keys_url": "https://api.github.com/repos/target/graphql-liftoff/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/graphql-liftoff/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/graphql-liftoff/teams",
        "hooks_url": "https://api.github.com/repos/target/graphql-liftoff/hooks",
        "issue_events_url": "https://api.github.com/repos/target/graphql-liftoff/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/graphql-liftoff/events",
        "assignees_url": "https://api.github.com/repos/target/graphql-liftoff/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/graphql-liftoff/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/graphql-liftoff/tags",
        "blobs_url": "https://api.github.com/repos/target/graphql-liftoff/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/graphql-liftoff/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/graphql-liftoff/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/graphql-liftoff/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/graphql-liftoff/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/graphql-liftoff/languages",
        "stargazers_url": "https://api.github.com/repos/target/graphql-liftoff/stargazers",
        "contributors_url": "https://api.github.com/repos/target/graphql-liftoff/contributors",
        "subscribers_url": "https://api.github.com/repos/target/graphql-liftoff/subscribers",
        "subscription_url": "https://api.github.com/repos/target/graphql-liftoff/subscription",
        "commits_url": "https://api.github.com/repos/target/graphql-liftoff/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/graphql-liftoff/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/graphql-liftoff/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/graphql-liftoff/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/graphql-liftoff/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/graphql-liftoff/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/graphql-liftoff/merges",
        "archive_url": "https://api.github.com/repos/target/graphql-liftoff/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/graphql-liftoff/downloads",
        "issues_url": "https://api.github.com/repos/target/graphql-liftoff/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/graphql-liftoff/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/graphql-liftoff/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/graphql-liftoff/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/graphql-liftoff/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/graphql-liftoff/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/graphql-liftoff/deployments",
        "created_at": "2017-10-19T15:37:53Z",
        "updated_at": "2018-12-13T08:27:26Z",
        "pushed_at": "2018-11-12T03:18:28Z",
        "git_url": "git://github.com/target/graphql-liftoff.git",
        "ssh_url": "git@github.com:target/graphql-liftoff.git",
        "clone_url": "https://github.com/target/graphql-liftoff.git",
        "svn_url": "https://github.com/target/graphql-liftoff",
        "homepage": "",
        "size": 285,
        "stargazers_count": 39,
        "watchers_count": 39,
        "language": "TypeScript",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 7,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 11,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [
            "definition",
            "generator",
            "graphql",
            "liftoff",
            "schema",
            "swagger",
            "type"
        ],
        "forks": 7,
        "open_issues": 11,
        "watchers": 39,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 108423461,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMDg0MjM0NjE=",
        "name": "gelvedere",
        "full_name": "target/gelvedere",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/gelvedere",
        "description": "Cli to deploy a Jenkins master",
        "fork": false,
        "url": "https://api.github.com/repos/target/gelvedere",
        "forks_url": "https://api.github.com/repos/target/gelvedere/forks",
        "keys_url": "https://api.github.com/repos/target/gelvedere/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/gelvedere/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/gelvedere/teams",
        "hooks_url": "https://api.github.com/repos/target/gelvedere/hooks",
        "issue_events_url": "https://api.github.com/repos/target/gelvedere/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/gelvedere/events",
        "assignees_url": "https://api.github.com/repos/target/gelvedere/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/gelvedere/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/gelvedere/tags",
        "blobs_url": "https://api.github.com/repos/target/gelvedere/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/gelvedere/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/gelvedere/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/gelvedere/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/gelvedere/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/gelvedere/languages",
        "stargazers_url": "https://api.github.com/repos/target/gelvedere/stargazers",
        "contributors_url": "https://api.github.com/repos/target/gelvedere/contributors",
        "subscribers_url": "https://api.github.com/repos/target/gelvedere/subscribers",
        "subscription_url": "https://api.github.com/repos/target/gelvedere/subscription",
        "commits_url": "https://api.github.com/repos/target/gelvedere/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/gelvedere/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/gelvedere/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/gelvedere/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/gelvedere/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/gelvedere/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/gelvedere/merges",
        "archive_url": "https://api.github.com/repos/target/gelvedere/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/gelvedere/downloads",
        "issues_url": "https://api.github.com/repos/target/gelvedere/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/gelvedere/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/gelvedere/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/gelvedere/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/gelvedere/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/gelvedere/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/gelvedere/deployments",
        "created_at": "2017-10-26T14:35:31Z",
        "updated_at": "2018-10-31T16:43:43Z",
        "pushed_at": "2018-10-31T16:43:42Z",
        "git_url": "git://github.com/target/gelvedere.git",
        "ssh_url": "git@github.com:target/gelvedere.git",
        "clone_url": "https://github.com/target/gelvedere.git",
        "svn_url": "https://github.com/target/gelvedere",
        "homepage": "",
        "size": 1212,
        "stargazers_count": 5,
        "watchers_count": 5,
        "language": "Go",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 1,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [
            "docker-swarm",
            "golang",
            "jenkins"
        ],
        "forks": 1,
        "open_issues": 1,
        "watchers": 5,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 110140812,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMTAxNDA4MTI=",
        "name": "hdp-cloud",
        "full_name": "target/hdp-cloud",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/hdp-cloud",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/target/hdp-cloud",
        "forks_url": "https://api.github.com/repos/target/hdp-cloud/forks",
        "keys_url": "https://api.github.com/repos/target/hdp-cloud/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/hdp-cloud/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/hdp-cloud/teams",
        "hooks_url": "https://api.github.com/repos/target/hdp-cloud/hooks",
        "issue_events_url": "https://api.github.com/repos/target/hdp-cloud/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/hdp-cloud/events",
        "assignees_url": "https://api.github.com/repos/target/hdp-cloud/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/hdp-cloud/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/hdp-cloud/tags",
        "blobs_url": "https://api.github.com/repos/target/hdp-cloud/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/hdp-cloud/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/hdp-cloud/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/hdp-cloud/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/hdp-cloud/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/hdp-cloud/languages",
        "stargazers_url": "https://api.github.com/repos/target/hdp-cloud/stargazers",
        "contributors_url": "https://api.github.com/repos/target/hdp-cloud/contributors",
        "subscribers_url": "https://api.github.com/repos/target/hdp-cloud/subscribers",
        "subscription_url": "https://api.github.com/repos/target/hdp-cloud/subscription",
        "commits_url": "https://api.github.com/repos/target/hdp-cloud/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/hdp-cloud/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/hdp-cloud/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/hdp-cloud/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/hdp-cloud/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/hdp-cloud/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/hdp-cloud/merges",
        "archive_url": "https://api.github.com/repos/target/hdp-cloud/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/hdp-cloud/downloads",
        "issues_url": "https://api.github.com/repos/target/hdp-cloud/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/hdp-cloud/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/hdp-cloud/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/hdp-cloud/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/hdp-cloud/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/hdp-cloud/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/hdp-cloud/deployments",
        "created_at": "2017-11-09T16:41:35Z",
        "updated_at": "2017-12-22T18:06:34Z",
        "pushed_at": "2017-11-16T17:38:07Z",
        "git_url": "git://github.com/target/hdp-cloud.git",
        "ssh_url": "git@github.com:target/hdp-cloud.git",
        "clone_url": "https://github.com/target/hdp-cloud.git",
        "svn_url": "https://github.com/target/hdp-cloud",
        "homepage": null,
        "size": 22,
        "stargazers_count": 1,
        "watchers_count": 1,
        "language": "Ruby",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [],
        "forks": 1,
        "open_issues": 0,
        "watchers": 1,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 110140840,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMTAxNDA4NDA=",
        "name": "REDstack",
        "full_name": "target/REDstack",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/REDstack",
        "description": "REDstack - Hadoop as a service on OpenStack",
        "fork": false,
        "url": "https://api.github.com/repos/target/REDstack",
        "forks_url": "https://api.github.com/repos/target/REDstack/forks",
        "keys_url": "https://api.github.com/repos/target/REDstack/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/REDstack/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/REDstack/teams",
        "hooks_url": "https://api.github.com/repos/target/REDstack/hooks",
        "issue_events_url": "https://api.github.com/repos/target/REDstack/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/REDstack/events",
        "assignees_url": "https://api.github.com/repos/target/REDstack/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/REDstack/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/REDstack/tags",
        "blobs_url": "https://api.github.com/repos/target/REDstack/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/REDstack/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/REDstack/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/REDstack/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/REDstack/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/REDstack/languages",
        "stargazers_url": "https://api.github.com/repos/target/REDstack/stargazers",
        "contributors_url": "https://api.github.com/repos/target/REDstack/contributors",
        "subscribers_url": "https://api.github.com/repos/target/REDstack/subscribers",
        "subscription_url": "https://api.github.com/repos/target/REDstack/subscription",
        "commits_url": "https://api.github.com/repos/target/REDstack/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/REDstack/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/REDstack/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/REDstack/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/REDstack/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/REDstack/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/REDstack/merges",
        "archive_url": "https://api.github.com/repos/target/REDstack/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/REDstack/downloads",
        "issues_url": "https://api.github.com/repos/target/REDstack/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/REDstack/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/REDstack/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/REDstack/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/REDstack/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/REDstack/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/REDstack/deployments",
        "created_at": "2017-11-09T16:41:52Z",
        "updated_at": "2018-10-15T13:48:14Z",
        "pushed_at": "2018-10-08T17:41:23Z",
        "git_url": "git://github.com/target/REDstack.git",
        "ssh_url": "git@github.com:target/REDstack.git",
        "clone_url": "https://github.com/target/REDstack.git",
        "svn_url": "https://github.com/target/REDstack",
        "homepage": "",
        "size": 51,
        "stargazers_count": 16,
        "watchers_count": 16,
        "language": "Python",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 9,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "apache-2.0",
            "name": "Apache License 2.0",
            "spdx_id": "Apache-2.0",
            "url": "https://api.github.com/licenses/apache-2.0",
            "node_id": "MDc6TGljZW5zZTI="
        },
        "topics": [
            "ambari",
            "cloud",
            "hadoop",
            "hdp",
            "openstack"
        ],
        "forks": 9,
        "open_issues": 0,
        "watchers": 16,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 118010955,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMTgwMTA5NTU=",
        "name": "row-types",
        "full_name": "target/row-types",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/row-types",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/target/row-types",
        "forks_url": "https://api.github.com/repos/target/row-types/forks",
        "keys_url": "https://api.github.com/repos/target/row-types/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/row-types/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/row-types/teams",
        "hooks_url": "https://api.github.com/repos/target/row-types/hooks",
        "issue_events_url": "https://api.github.com/repos/target/row-types/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/row-types/events",
        "assignees_url": "https://api.github.com/repos/target/row-types/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/row-types/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/row-types/tags",
        "blobs_url": "https://api.github.com/repos/target/row-types/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/row-types/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/row-types/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/row-types/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/row-types/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/row-types/languages",
        "stargazers_url": "https://api.github.com/repos/target/row-types/stargazers",
        "contributors_url": "https://api.github.com/repos/target/row-types/contributors",
        "subscribers_url": "https://api.github.com/repos/target/row-types/subscribers",
        "subscription_url": "https://api.github.com/repos/target/row-types/subscription",
        "commits_url": "https://api.github.com/repos/target/row-types/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/row-types/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/row-types/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/row-types/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/row-types/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/row-types/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/row-types/merges",
        "archive_url": "https://api.github.com/repos/target/row-types/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/row-types/downloads",
        "issues_url": "https://api.github.com/repos/target/row-types/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/row-types/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/row-types/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/row-types/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/row-types/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/row-types/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/row-types/deployments",
        "created_at": "2018-01-18T16:51:48Z",
        "updated_at": "2018-12-08T02:31:24Z",
        "pushed_at": "2018-09-04T19:32:38Z",
        "git_url": "git://github.com/target/row-types.git",
        "ssh_url": "git@github.com:target/row-types.git",
        "clone_url": "https://github.com/target/row-types.git",
        "svn_url": "https://github.com/target/row-types",
        "homepage": null,
        "size": 247,
        "stargazers_count": 45,
        "watchers_count": 45,
        "language": "Haskell",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 5,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 2,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [],
        "forks": 5,
        "open_issues": 2,
        "watchers": 45,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 118011626,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMTgwMTE2MjY=",
        "name": "react-native-svg-parser",
        "full_name": "target/react-native-svg-parser",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/react-native-svg-parser",
        "description": "Parses SVG files and converts to 'react-native-svg' format objects. NOTE: This project has been archived.",
        "fork": false,
        "url": "https://api.github.com/repos/target/react-native-svg-parser",
        "forks_url": "https://api.github.com/repos/target/react-native-svg-parser/forks",
        "keys_url": "https://api.github.com/repos/target/react-native-svg-parser/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/react-native-svg-parser/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/react-native-svg-parser/teams",
        "hooks_url": "https://api.github.com/repos/target/react-native-svg-parser/hooks",
        "issue_events_url": "https://api.github.com/repos/target/react-native-svg-parser/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/react-native-svg-parser/events",
        "assignees_url": "https://api.github.com/repos/target/react-native-svg-parser/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/react-native-svg-parser/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/react-native-svg-parser/tags",
        "blobs_url": "https://api.github.com/repos/target/react-native-svg-parser/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/react-native-svg-parser/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/react-native-svg-parser/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/react-native-svg-parser/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/react-native-svg-parser/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/react-native-svg-parser/languages",
        "stargazers_url": "https://api.github.com/repos/target/react-native-svg-parser/stargazers",
        "contributors_url": "https://api.github.com/repos/target/react-native-svg-parser/contributors",
        "subscribers_url": "https://api.github.com/repos/target/react-native-svg-parser/subscribers",
        "subscription_url": "https://api.github.com/repos/target/react-native-svg-parser/subscription",
        "commits_url": "https://api.github.com/repos/target/react-native-svg-parser/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/react-native-svg-parser/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/react-native-svg-parser/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/react-native-svg-parser/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/react-native-svg-parser/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/react-native-svg-parser/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/react-native-svg-parser/merges",
        "archive_url": "https://api.github.com/repos/target/react-native-svg-parser/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/react-native-svg-parser/downloads",
        "issues_url": "https://api.github.com/repos/target/react-native-svg-parser/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/react-native-svg-parser/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/react-native-svg-parser/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/react-native-svg-parser/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/react-native-svg-parser/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/react-native-svg-parser/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/react-native-svg-parser/deployments",
        "created_at": "2018-01-18T16:57:31Z",
        "updated_at": "2018-11-09T00:24:15Z",
        "pushed_at": "2018-11-09T00:14:53Z",
        "git_url": "git://github.com/target/react-native-svg-parser.git",
        "ssh_url": "git@github.com:target/react-native-svg-parser.git",
        "clone_url": "https://github.com/target/react-native-svg-parser.git",
        "svn_url": "https://github.com/target/react-native-svg-parser",
        "homepage": "",
        "size": 134,
        "stargazers_count": 40,
        "watchers_count": 40,
        "language": "JavaScript",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 10,
        "mirror_url": null,
        "archived": true,
        "open_issues_count": 11,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [
            "archived",
            "react",
            "react-native",
            "svg"
        ],
        "forks": 10,
        "open_issues": 11,
        "watchers": 40,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 120789346,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMjA3ODkzNDY=",
        "name": "jenkins-docker-api",
        "full_name": "target/jenkins-docker-api",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/jenkins-docker-api",
        "description": "An API to manage containerized Jenkins masters",
        "fork": false,
        "url": "https://api.github.com/repos/target/jenkins-docker-api",
        "forks_url": "https://api.github.com/repos/target/jenkins-docker-api/forks",
        "keys_url": "https://api.github.com/repos/target/jenkins-docker-api/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/jenkins-docker-api/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/jenkins-docker-api/teams",
        "hooks_url": "https://api.github.com/repos/target/jenkins-docker-api/hooks",
        "issue_events_url": "https://api.github.com/repos/target/jenkins-docker-api/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/jenkins-docker-api/events",
        "assignees_url": "https://api.github.com/repos/target/jenkins-docker-api/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/jenkins-docker-api/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/jenkins-docker-api/tags",
        "blobs_url": "https://api.github.com/repos/target/jenkins-docker-api/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/jenkins-docker-api/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/jenkins-docker-api/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/jenkins-docker-api/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/jenkins-docker-api/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/jenkins-docker-api/languages",
        "stargazers_url": "https://api.github.com/repos/target/jenkins-docker-api/stargazers",
        "contributors_url": "https://api.github.com/repos/target/jenkins-docker-api/contributors",
        "subscribers_url": "https://api.github.com/repos/target/jenkins-docker-api/subscribers",
        "subscription_url": "https://api.github.com/repos/target/jenkins-docker-api/subscription",
        "commits_url": "https://api.github.com/repos/target/jenkins-docker-api/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/jenkins-docker-api/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/jenkins-docker-api/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/jenkins-docker-api/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/jenkins-docker-api/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/jenkins-docker-api/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/jenkins-docker-api/merges",
        "archive_url": "https://api.github.com/repos/target/jenkins-docker-api/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/jenkins-docker-api/downloads",
        "issues_url": "https://api.github.com/repos/target/jenkins-docker-api/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/jenkins-docker-api/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/jenkins-docker-api/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/jenkins-docker-api/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/jenkins-docker-api/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/jenkins-docker-api/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/jenkins-docker-api/deployments",
        "created_at": "2018-02-08T16:48:51Z",
        "updated_at": "2018-09-05T19:56:03Z",
        "pushed_at": "2018-02-15T21:19:17Z",
        "git_url": "git://github.com/target/jenkins-docker-api.git",
        "ssh_url": "git@github.com:target/jenkins-docker-api.git",
        "clone_url": "https://github.com/target/jenkins-docker-api.git",
        "svn_url": "https://github.com/target/jenkins-docker-api",
        "homepage": "",
        "size": 9527,
        "stargazers_count": 5,
        "watchers_count": 5,
        "language": "Go",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 2,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 2,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [
            "docker",
            "golang",
            "jenkins"
        ],
        "forks": 2,
        "open_issues": 2,
        "watchers": 5,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 120789762,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMjA3ODk3NjI=",
        "name": "setupcfg2nix",
        "full_name": "target/setupcfg2nix",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/setupcfg2nix",
        "description": "Generate nix expressions from setup.cfg for a python package.",
        "fork": false,
        "url": "https://api.github.com/repos/target/setupcfg2nix",
        "forks_url": "https://api.github.com/repos/target/setupcfg2nix/forks",
        "keys_url": "https://api.github.com/repos/target/setupcfg2nix/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/setupcfg2nix/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/setupcfg2nix/teams",
        "hooks_url": "https://api.github.com/repos/target/setupcfg2nix/hooks",
        "issue_events_url": "https://api.github.com/repos/target/setupcfg2nix/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/setupcfg2nix/events",
        "assignees_url": "https://api.github.com/repos/target/setupcfg2nix/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/setupcfg2nix/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/setupcfg2nix/tags",
        "blobs_url": "https://api.github.com/repos/target/setupcfg2nix/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/setupcfg2nix/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/setupcfg2nix/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/setupcfg2nix/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/setupcfg2nix/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/setupcfg2nix/languages",
        "stargazers_url": "https://api.github.com/repos/target/setupcfg2nix/stargazers",
        "contributors_url": "https://api.github.com/repos/target/setupcfg2nix/contributors",
        "subscribers_url": "https://api.github.com/repos/target/setupcfg2nix/subscribers",
        "subscription_url": "https://api.github.com/repos/target/setupcfg2nix/subscription",
        "commits_url": "https://api.github.com/repos/target/setupcfg2nix/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/setupcfg2nix/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/setupcfg2nix/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/setupcfg2nix/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/setupcfg2nix/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/setupcfg2nix/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/setupcfg2nix/merges",
        "archive_url": "https://api.github.com/repos/target/setupcfg2nix/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/setupcfg2nix/downloads",
        "issues_url": "https://api.github.com/repos/target/setupcfg2nix/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/setupcfg2nix/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/setupcfg2nix/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/setupcfg2nix/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/setupcfg2nix/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/setupcfg2nix/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/setupcfg2nix/deployments",
        "created_at": "2018-02-08T16:52:35Z",
        "updated_at": "2018-04-15T20:41:40Z",
        "pushed_at": "2018-04-15T20:41:49Z",
        "git_url": "git://github.com/target/setupcfg2nix.git",
        "ssh_url": "git@github.com:target/setupcfg2nix.git",
        "clone_url": "https://github.com/target/setupcfg2nix.git",
        "svn_url": "https://github.com/target/setupcfg2nix",
        "homepage": "",
        "size": 21,
        "stargazers_count": 1,
        "watchers_count": 1,
        "language": "Python",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [],
        "forks": 0,
        "open_issues": 0,
        "watchers": 1,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 128227460,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMjgyMjc0NjA=",
        "name": "table-model",
        "full_name": "target/table-model",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/table-model",
        "description": "Supercharge your datagrid with TableModel",
        "fork": false,
        "url": "https://api.github.com/repos/target/table-model",
        "forks_url": "https://api.github.com/repos/target/table-model/forks",
        "keys_url": "https://api.github.com/repos/target/table-model/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/table-model/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/table-model/teams",
        "hooks_url": "https://api.github.com/repos/target/table-model/hooks",
        "issue_events_url": "https://api.github.com/repos/target/table-model/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/table-model/events",
        "assignees_url": "https://api.github.com/repos/target/table-model/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/table-model/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/table-model/tags",
        "blobs_url": "https://api.github.com/repos/target/table-model/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/table-model/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/table-model/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/table-model/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/table-model/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/table-model/languages",
        "stargazers_url": "https://api.github.com/repos/target/table-model/stargazers",
        "contributors_url": "https://api.github.com/repos/target/table-model/contributors",
        "subscribers_url": "https://api.github.com/repos/target/table-model/subscribers",
        "subscription_url": "https://api.github.com/repos/target/table-model/subscription",
        "commits_url": "https://api.github.com/repos/target/table-model/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/table-model/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/table-model/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/table-model/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/table-model/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/table-model/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/table-model/merges",
        "archive_url": "https://api.github.com/repos/target/table-model/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/table-model/downloads",
        "issues_url": "https://api.github.com/repos/target/table-model/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/table-model/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/table-model/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/table-model/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/table-model/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/table-model/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/table-model/deployments",
        "created_at": "2018-04-05T15:39:26Z",
        "updated_at": "2018-12-23T16:36:12Z",
        "pushed_at": "2018-12-23T16:36:10Z",
        "git_url": "git://github.com/target/table-model.git",
        "ssh_url": "git@github.com:target/table-model.git",
        "clone_url": "https://github.com/target/table-model.git",
        "svn_url": "https://github.com/target/table-model",
        "homepage": "",
        "size": 1497,
        "stargazers_count": 9,
        "watchers_count": 9,
        "language": "JavaScript",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": true,
        "forks_count": 3,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [
            "aggrid",
            "automatic",
            "datagrid",
            "datamodel",
            "dependency-tracker",
            "javascript"
        ],
        "forks": 3,
        "open_issues": 0,
        "watchers": 9,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 130397135,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMzAzOTcxMzU=",
        "name": "charts",
        "full_name": "target/charts",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/charts",
        "description": "Curated applications for Kubernetes",
        "fork": true,
        "url": "https://api.github.com/repos/target/charts",
        "forks_url": "https://api.github.com/repos/target/charts/forks",
        "keys_url": "https://api.github.com/repos/target/charts/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/charts/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/charts/teams",
        "hooks_url": "https://api.github.com/repos/target/charts/hooks",
        "issue_events_url": "https://api.github.com/repos/target/charts/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/charts/events",
        "assignees_url": "https://api.github.com/repos/target/charts/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/charts/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/charts/tags",
        "blobs_url": "https://api.github.com/repos/target/charts/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/charts/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/charts/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/charts/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/charts/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/charts/languages",
        "stargazers_url": "https://api.github.com/repos/target/charts/stargazers",
        "contributors_url": "https://api.github.com/repos/target/charts/contributors",
        "subscribers_url": "https://api.github.com/repos/target/charts/subscribers",
        "subscription_url": "https://api.github.com/repos/target/charts/subscription",
        "commits_url": "https://api.github.com/repos/target/charts/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/charts/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/charts/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/charts/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/charts/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/charts/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/charts/merges",
        "archive_url": "https://api.github.com/repos/target/charts/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/charts/downloads",
        "issues_url": "https://api.github.com/repos/target/charts/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/charts/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/charts/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/charts/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/charts/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/charts/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/charts/deployments",
        "created_at": "2018-04-20T18:02:26Z",
        "updated_at": "2018-07-19T19:52:14Z",
        "pushed_at": "2018-04-20T17:33:07Z",
        "git_url": "git://github.com/target/charts.git",
        "ssh_url": "git@github.com:target/charts.git",
        "clone_url": "https://github.com/target/charts.git",
        "svn_url": "https://github.com/target/charts",
        "homepage": "",
        "size": 6845,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Smarty",
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 1,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "apache-2.0",
            "name": "Apache License 2.0",
            "spdx_id": "Apache-2.0",
            "url": "https://api.github.com/licenses/apache-2.0",
            "node_id": "MDc6TGljZW5zZTI="
        },
        "topics": [],
        "forks": 1,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 130705740,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMzA3MDU3NDA=",
        "name": "haproxy_exporter",
        "full_name": "target/haproxy_exporter",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/haproxy_exporter",
        "description": "Simple server that scrapes HAProxy stats and exports them via HTTP for Prometheus consumption",
        "fork": true,
        "url": "https://api.github.com/repos/target/haproxy_exporter",
        "forks_url": "https://api.github.com/repos/target/haproxy_exporter/forks",
        "keys_url": "https://api.github.com/repos/target/haproxy_exporter/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/haproxy_exporter/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/haproxy_exporter/teams",
        "hooks_url": "https://api.github.com/repos/target/haproxy_exporter/hooks",
        "issue_events_url": "https://api.github.com/repos/target/haproxy_exporter/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/haproxy_exporter/events",
        "assignees_url": "https://api.github.com/repos/target/haproxy_exporter/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/haproxy_exporter/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/haproxy_exporter/tags",
        "blobs_url": "https://api.github.com/repos/target/haproxy_exporter/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/haproxy_exporter/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/haproxy_exporter/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/haproxy_exporter/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/haproxy_exporter/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/haproxy_exporter/languages",
        "stargazers_url": "https://api.github.com/repos/target/haproxy_exporter/stargazers",
        "contributors_url": "https://api.github.com/repos/target/haproxy_exporter/contributors",
        "subscribers_url": "https://api.github.com/repos/target/haproxy_exporter/subscribers",
        "subscription_url": "https://api.github.com/repos/target/haproxy_exporter/subscription",
        "commits_url": "https://api.github.com/repos/target/haproxy_exporter/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/haproxy_exporter/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/haproxy_exporter/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/haproxy_exporter/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/haproxy_exporter/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/haproxy_exporter/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/haproxy_exporter/merges",
        "archive_url": "https://api.github.com/repos/target/haproxy_exporter/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/haproxy_exporter/downloads",
        "issues_url": "https://api.github.com/repos/target/haproxy_exporter/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/haproxy_exporter/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/haproxy_exporter/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/haproxy_exporter/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/haproxy_exporter/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/haproxy_exporter/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/haproxy_exporter/deployments",
        "created_at": "2018-04-23T14:04:24Z",
        "updated_at": "2018-04-23T14:04:26Z",
        "pushed_at": "2018-03-07T07:06:06Z",
        "git_url": "git://github.com/target/haproxy_exporter.git",
        "ssh_url": "git@github.com:target/haproxy_exporter.git",
        "clone_url": "https://github.com/target/haproxy_exporter.git",
        "svn_url": "https://github.com/target/haproxy_exporter",
        "homepage": "",
        "size": 905,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Go",
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": false,
        "has_pages": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "apache-2.0",
            "name": "Apache License 2.0",
            "spdx_id": "Apache-2.0",
            "url": "https://api.github.com/licenses/apache-2.0",
            "node_id": "MDc6TGljZW5zZTI="
        },
        "topics": [],
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 131608800,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMzE2MDg4MDA=",
        "name": "portauthority",
        "full_name": "target/portauthority",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/portauthority",
        "description": "API that leverages Clair to scan Docker Registries and Kubernetes Clusters for vulnerabilities",
        "fork": false,
        "url": "https://api.github.com/repos/target/portauthority",
        "forks_url": "https://api.github.com/repos/target/portauthority/forks",
        "keys_url": "https://api.github.com/repos/target/portauthority/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/portauthority/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/portauthority/teams",
        "hooks_url": "https://api.github.com/repos/target/portauthority/hooks",
        "issue_events_url": "https://api.github.com/repos/target/portauthority/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/portauthority/events",
        "assignees_url": "https://api.github.com/repos/target/portauthority/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/portauthority/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/portauthority/tags",
        "blobs_url": "https://api.github.com/repos/target/portauthority/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/portauthority/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/portauthority/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/portauthority/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/portauthority/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/portauthority/languages",
        "stargazers_url": "https://api.github.com/repos/target/portauthority/stargazers",
        "contributors_url": "https://api.github.com/repos/target/portauthority/contributors",
        "subscribers_url": "https://api.github.com/repos/target/portauthority/subscribers",
        "subscription_url": "https://api.github.com/repos/target/portauthority/subscription",
        "commits_url": "https://api.github.com/repos/target/portauthority/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/portauthority/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/portauthority/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/portauthority/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/portauthority/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/portauthority/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/portauthority/merges",
        "archive_url": "https://api.github.com/repos/target/portauthority/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/portauthority/downloads",
        "issues_url": "https://api.github.com/repos/target/portauthority/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/portauthority/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/portauthority/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/portauthority/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/portauthority/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/portauthority/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/portauthority/deployments",
        "created_at": "2018-04-30T14:52:31Z",
        "updated_at": "2018-11-29T08:18:23Z",
        "pushed_at": "2018-10-18T18:04:33Z",
        "git_url": "git://github.com/target/portauthority.git",
        "ssh_url": "git@github.com:target/portauthority.git",
        "clone_url": "https://github.com/target/portauthority.git",
        "svn_url": "https://github.com/target/portauthority",
        "homepage": "",
        "size": 610,
        "stargazers_count": 112,
        "watchers_count": 112,
        "language": "Go",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 17,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 6,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [
            "clair",
            "docker-image",
            "golang",
            "kubernetes",
            "policy-engine",
            "vulnerability-assessment"
        ],
        "forks": 17,
        "open_issues": 6,
        "watchers": 112,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 132016212,
        "node_id": "MDEwOlJlcG9zaXRvcnkxMzIwMTYyMTI=",
        "name": "nix-fetchers",
        "full_name": "target/nix-fetchers",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/nix-fetchers",
        "description": "A set of morally pure fetching builtins for Nix.",
        "fork": false,
        "url": "https://api.github.com/repos/target/nix-fetchers",
        "forks_url": "https://api.github.com/repos/target/nix-fetchers/forks",
        "keys_url": "https://api.github.com/repos/target/nix-fetchers/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/nix-fetchers/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/nix-fetchers/teams",
        "hooks_url": "https://api.github.com/repos/target/nix-fetchers/hooks",
        "issue_events_url": "https://api.github.com/repos/target/nix-fetchers/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/nix-fetchers/events",
        "assignees_url": "https://api.github.com/repos/target/nix-fetchers/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/nix-fetchers/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/nix-fetchers/tags",
        "blobs_url": "https://api.github.com/repos/target/nix-fetchers/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/nix-fetchers/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/nix-fetchers/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/nix-fetchers/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/nix-fetchers/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/nix-fetchers/languages",
        "stargazers_url": "https://api.github.com/repos/target/nix-fetchers/stargazers",
        "contributors_url": "https://api.github.com/repos/target/nix-fetchers/contributors",
        "subscribers_url": "https://api.github.com/repos/target/nix-fetchers/subscribers",
        "subscription_url": "https://api.github.com/repos/target/nix-fetchers/subscription",
        "commits_url": "https://api.github.com/repos/target/nix-fetchers/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/nix-fetchers/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/nix-fetchers/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/nix-fetchers/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/nix-fetchers/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/nix-fetchers/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/nix-fetchers/merges",
        "archive_url": "https://api.github.com/repos/target/nix-fetchers/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/nix-fetchers/downloads",
        "issues_url": "https://api.github.com/repos/target/nix-fetchers/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/nix-fetchers/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/nix-fetchers/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/nix-fetchers/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/nix-fetchers/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/nix-fetchers/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/nix-fetchers/deployments",
        "created_at": "2018-05-03T15:38:10Z",
        "updated_at": "2018-12-21T22:41:57Z",
        "pushed_at": "2018-11-06T13:03:52Z",
        "git_url": "git://github.com/target/nix-fetchers.git",
        "ssh_url": "git@github.com:target/nix-fetchers.git",
        "clone_url": "https://github.com/target/nix-fetchers.git",
        "svn_url": "https://github.com/target/nix-fetchers",
        "homepage": "",
        "size": 50,
        "stargazers_count": 23,
        "watchers_count": 23,
        "language": "Python",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 3,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 4,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [],
        "forks": 3,
        "open_issues": 4,
        "watchers": 23,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 140453984,
        "node_id": "MDEwOlJlcG9zaXRvcnkxNDA0NTM5ODQ=",
        "name": "go-arty",
        "full_name": "target/go-arty",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/go-arty",
        "description": "Go client library for Artifactory and Xray",
        "fork": false,
        "url": "https://api.github.com/repos/target/go-arty",
        "forks_url": "https://api.github.com/repos/target/go-arty/forks",
        "keys_url": "https://api.github.com/repos/target/go-arty/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/go-arty/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/go-arty/teams",
        "hooks_url": "https://api.github.com/repos/target/go-arty/hooks",
        "issue_events_url": "https://api.github.com/repos/target/go-arty/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/go-arty/events",
        "assignees_url": "https://api.github.com/repos/target/go-arty/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/go-arty/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/go-arty/tags",
        "blobs_url": "https://api.github.com/repos/target/go-arty/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/go-arty/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/go-arty/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/go-arty/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/go-arty/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/go-arty/languages",
        "stargazers_url": "https://api.github.com/repos/target/go-arty/stargazers",
        "contributors_url": "https://api.github.com/repos/target/go-arty/contributors",
        "subscribers_url": "https://api.github.com/repos/target/go-arty/subscribers",
        "subscription_url": "https://api.github.com/repos/target/go-arty/subscription",
        "commits_url": "https://api.github.com/repos/target/go-arty/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/go-arty/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/go-arty/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/go-arty/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/go-arty/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/go-arty/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/go-arty/merges",
        "archive_url": "https://api.github.com/repos/target/go-arty/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/go-arty/downloads",
        "issues_url": "https://api.github.com/repos/target/go-arty/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/go-arty/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/go-arty/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/go-arty/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/go-arty/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/go-arty/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/go-arty/deployments",
        "created_at": "2018-07-10T15:38:56Z",
        "updated_at": "2018-12-14T21:14:00Z",
        "pushed_at": "2018-12-20T21:01:46Z",
        "git_url": "git://github.com/target/go-arty.git",
        "ssh_url": "git@github.com:target/go-arty.git",
        "clone_url": "https://github.com/target/go-arty.git",
        "svn_url": "https://github.com/target/go-arty",
        "homepage": "",
        "size": 113,
        "stargazers_count": 17,
        "watchers_count": 17,
        "language": "Go",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 3,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 3,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [
            "api",
            "artifactory",
            "go",
            "golang",
            "library",
            "xray"
        ],
        "forks": 3,
        "open_issues": 3,
        "watchers": 17,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 140861690,
        "node_id": "MDEwOlJlcG9zaXRvcnkxNDA4NjE2OTA=",
        "name": "flottbot",
        "full_name": "target/flottbot",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/flottbot",
        "description": " A chatbot framework written in Go. All configurations are made in YAML files, or inside scripts written in your favorite language.",
        "fork": false,
        "url": "https://api.github.com/repos/target/flottbot",
        "forks_url": "https://api.github.com/repos/target/flottbot/forks",
        "keys_url": "https://api.github.com/repos/target/flottbot/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/flottbot/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/flottbot/teams",
        "hooks_url": "https://api.github.com/repos/target/flottbot/hooks",
        "issue_events_url": "https://api.github.com/repos/target/flottbot/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/flottbot/events",
        "assignees_url": "https://api.github.com/repos/target/flottbot/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/flottbot/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/flottbot/tags",
        "blobs_url": "https://api.github.com/repos/target/flottbot/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/flottbot/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/flottbot/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/flottbot/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/flottbot/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/flottbot/languages",
        "stargazers_url": "https://api.github.com/repos/target/flottbot/stargazers",
        "contributors_url": "https://api.github.com/repos/target/flottbot/contributors",
        "subscribers_url": "https://api.github.com/repos/target/flottbot/subscribers",
        "subscription_url": "https://api.github.com/repos/target/flottbot/subscription",
        "commits_url": "https://api.github.com/repos/target/flottbot/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/flottbot/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/flottbot/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/flottbot/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/flottbot/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/flottbot/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/flottbot/merges",
        "archive_url": "https://api.github.com/repos/target/flottbot/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/flottbot/downloads",
        "issues_url": "https://api.github.com/repos/target/flottbot/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/flottbot/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/flottbot/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/flottbot/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/flottbot/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/flottbot/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/flottbot/deployments",
        "created_at": "2018-07-13T15:08:17Z",
        "updated_at": "2018-12-26T20:55:40Z",
        "pushed_at": "2018-12-20T19:18:17Z",
        "git_url": "git://github.com/target/flottbot.git",
        "ssh_url": "git@github.com:target/flottbot.git",
        "clone_url": "https://github.com/target/flottbot.git",
        "svn_url": "https://github.com/target/flottbot",
        "homepage": "https://target.github.io/flottbot-docs/",
        "size": 130,
        "stargazers_count": 28,
        "watchers_count": 28,
        "language": "Go",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": false,
        "has_pages": false,
        "forks_count": 6,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 37,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [
            "bot",
            "chatbot",
            "chatbot-framework",
            "chatops",
            "discord",
            "easy",
            "golang",
            "slack",
            "yaml"
        ],
        "forks": 6,
        "open_issues": 37,
        "watchers": 28,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 141473317,
        "node_id": "MDEwOlJlcG9zaXRvcnkxNDE0NzMzMTc=",
        "name": "flottbot-docs",
        "full_name": "target/flottbot-docs",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/flottbot-docs",
        "description": "Docsite for flottbot",
        "fork": false,
        "url": "https://api.github.com/repos/target/flottbot-docs",
        "forks_url": "https://api.github.com/repos/target/flottbot-docs/forks",
        "keys_url": "https://api.github.com/repos/target/flottbot-docs/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/flottbot-docs/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/flottbot-docs/teams",
        "hooks_url": "https://api.github.com/repos/target/flottbot-docs/hooks",
        "issue_events_url": "https://api.github.com/repos/target/flottbot-docs/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/flottbot-docs/events",
        "assignees_url": "https://api.github.com/repos/target/flottbot-docs/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/flottbot-docs/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/flottbot-docs/tags",
        "blobs_url": "https://api.github.com/repos/target/flottbot-docs/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/flottbot-docs/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/flottbot-docs/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/flottbot-docs/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/flottbot-docs/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/flottbot-docs/languages",
        "stargazers_url": "https://api.github.com/repos/target/flottbot-docs/stargazers",
        "contributors_url": "https://api.github.com/repos/target/flottbot-docs/contributors",
        "subscribers_url": "https://api.github.com/repos/target/flottbot-docs/subscribers",
        "subscription_url": "https://api.github.com/repos/target/flottbot-docs/subscription",
        "commits_url": "https://api.github.com/repos/target/flottbot-docs/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/flottbot-docs/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/flottbot-docs/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/flottbot-docs/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/flottbot-docs/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/flottbot-docs/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/flottbot-docs/merges",
        "archive_url": "https://api.github.com/repos/target/flottbot-docs/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/flottbot-docs/downloads",
        "issues_url": "https://api.github.com/repos/target/flottbot-docs/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/flottbot-docs/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/flottbot-docs/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/flottbot-docs/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/flottbot-docs/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/flottbot-docs/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/flottbot-docs/deployments",
        "created_at": "2018-07-18T18:17:41Z",
        "updated_at": "2018-11-13T15:06:58Z",
        "pushed_at": "2018-11-13T15:08:00Z",
        "git_url": "git://github.com/target/flottbot-docs.git",
        "ssh_url": "git@github.com:target/flottbot-docs.git",
        "clone_url": "https://github.com/target/flottbot-docs.git",
        "svn_url": "https://github.com/target/flottbot-docs",
        "homepage": "https://target.github.io/flottbot-docs/",
        "size": 639,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "JavaScript",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": false,
        "has_pages": true,
        "forks_count": 2,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 10,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [
            "chatops",
            "documentation",
            "flottbot"
        ],
        "forks": 2,
        "open_issues": 10,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 144194502,
        "node_id": "MDEwOlJlcG9zaXRvcnkxNDQxOTQ1MDI=",
        "name": "captains-log",
        "full_name": "target/captains-log",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/captains-log",
        "description": "👩\u200d✈️ - A Drone plugin that helps organize release information in slack - 📝",
        "fork": false,
        "url": "https://api.github.com/repos/target/captains-log",
        "forks_url": "https://api.github.com/repos/target/captains-log/forks",
        "keys_url": "https://api.github.com/repos/target/captains-log/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/captains-log/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/captains-log/teams",
        "hooks_url": "https://api.github.com/repos/target/captains-log/hooks",
        "issue_events_url": "https://api.github.com/repos/target/captains-log/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/captains-log/events",
        "assignees_url": "https://api.github.com/repos/target/captains-log/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/captains-log/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/captains-log/tags",
        "blobs_url": "https://api.github.com/repos/target/captains-log/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/captains-log/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/captains-log/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/captains-log/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/captains-log/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/captains-log/languages",
        "stargazers_url": "https://api.github.com/repos/target/captains-log/stargazers",
        "contributors_url": "https://api.github.com/repos/target/captains-log/contributors",
        "subscribers_url": "https://api.github.com/repos/target/captains-log/subscribers",
        "subscription_url": "https://api.github.com/repos/target/captains-log/subscription",
        "commits_url": "https://api.github.com/repos/target/captains-log/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/captains-log/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/captains-log/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/captains-log/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/captains-log/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/captains-log/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/captains-log/merges",
        "archive_url": "https://api.github.com/repos/target/captains-log/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/captains-log/downloads",
        "issues_url": "https://api.github.com/repos/target/captains-log/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/captains-log/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/captains-log/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/captains-log/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/captains-log/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/captains-log/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/captains-log/deployments",
        "created_at": "2018-08-09T19:23:06Z",
        "updated_at": "2018-12-18T20:14:33Z",
        "pushed_at": "2018-12-18T20:16:41Z",
        "git_url": "git://github.com/target/captains-log.git",
        "ssh_url": "git@github.com:target/captains-log.git",
        "clone_url": "https://github.com/target/captains-log.git",
        "svn_url": "https://github.com/target/captains-log",
        "homepage": "https://target.github.io/captains-log/",
        "size": 180,
        "stargazers_count": 16,
        "watchers_count": 16,
        "language": "JavaScript",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": true,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 2,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [
            "ci",
            "drone",
            "drone-ci",
            "drone-plugin",
            "javascript",
            "nodejs",
            "release",
            "release-automation",
            "slack"
        ],
        "forks": 0,
        "open_issues": 2,
        "watchers": 16,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 145124511,
        "node_id": "MDEwOlJlcG9zaXRvcnkxNDUxMjQ1MTE=",
        "name": "istio",
        "full_name": "target/istio",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/istio",
        "description": "Connect, secure, control, and observe services.",
        "fork": true,
        "url": "https://api.github.com/repos/target/istio",
        "forks_url": "https://api.github.com/repos/target/istio/forks",
        "keys_url": "https://api.github.com/repos/target/istio/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/istio/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/istio/teams",
        "hooks_url": "https://api.github.com/repos/target/istio/hooks",
        "issue_events_url": "https://api.github.com/repos/target/istio/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/istio/events",
        "assignees_url": "https://api.github.com/repos/target/istio/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/istio/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/istio/tags",
        "blobs_url": "https://api.github.com/repos/target/istio/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/istio/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/istio/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/istio/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/istio/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/istio/languages",
        "stargazers_url": "https://api.github.com/repos/target/istio/stargazers",
        "contributors_url": "https://api.github.com/repos/target/istio/contributors",
        "subscribers_url": "https://api.github.com/repos/target/istio/subscribers",
        "subscription_url": "https://api.github.com/repos/target/istio/subscription",
        "commits_url": "https://api.github.com/repos/target/istio/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/istio/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/istio/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/istio/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/istio/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/istio/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/istio/merges",
        "archive_url": "https://api.github.com/repos/target/istio/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/istio/downloads",
        "issues_url": "https://api.github.com/repos/target/istio/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/istio/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/istio/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/istio/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/istio/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/istio/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/istio/deployments",
        "created_at": "2018-08-17T13:35:23Z",
        "updated_at": "2018-11-02T22:19:32Z",
        "pushed_at": "2018-11-02T22:57:04Z",
        "git_url": "git://github.com/target/istio.git",
        "ssh_url": "git@github.com:target/istio.git",
        "clone_url": "https://github.com/target/istio.git",
        "svn_url": "https://github.com/target/istio",
        "homepage": "https://istio.io",
        "size": 52656,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Go",
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "apache-2.0",
            "name": "Apache License 2.0",
            "spdx_id": "Apache-2.0",
            "url": "https://api.github.com/licenses/apache-2.0",
            "node_id": "MDc6TGljZW5zZTI="
        },
        "topics": [],
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 146933965,
        "node_id": "MDEwOlJlcG9zaXRvcnkxNDY5MzM5NjU=",
        "name": "huntlib",
        "full_name": "target/huntlib",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/huntlib",
        "description": "A Python library to help with some common threat hunting data analysis operations",
        "fork": false,
        "url": "https://api.github.com/repos/target/huntlib",
        "forks_url": "https://api.github.com/repos/target/huntlib/forks",
        "keys_url": "https://api.github.com/repos/target/huntlib/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/huntlib/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/huntlib/teams",
        "hooks_url": "https://api.github.com/repos/target/huntlib/hooks",
        "issue_events_url": "https://api.github.com/repos/target/huntlib/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/huntlib/events",
        "assignees_url": "https://api.github.com/repos/target/huntlib/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/huntlib/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/huntlib/tags",
        "blobs_url": "https://api.github.com/repos/target/huntlib/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/huntlib/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/huntlib/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/huntlib/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/huntlib/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/huntlib/languages",
        "stargazers_url": "https://api.github.com/repos/target/huntlib/stargazers",
        "contributors_url": "https://api.github.com/repos/target/huntlib/contributors",
        "subscribers_url": "https://api.github.com/repos/target/huntlib/subscribers",
        "subscription_url": "https://api.github.com/repos/target/huntlib/subscription",
        "commits_url": "https://api.github.com/repos/target/huntlib/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/huntlib/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/huntlib/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/huntlib/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/huntlib/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/huntlib/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/huntlib/merges",
        "archive_url": "https://api.github.com/repos/target/huntlib/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/huntlib/downloads",
        "issues_url": "https://api.github.com/repos/target/huntlib/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/huntlib/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/huntlib/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/huntlib/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/huntlib/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/huntlib/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/huntlib/deployments",
        "created_at": "2018-08-31T19:21:27Z",
        "updated_at": "2018-11-17T17:02:34Z",
        "pushed_at": "2018-10-23T15:48:55Z",
        "git_url": "git://github.com/target/huntlib.git",
        "ssh_url": "git@github.com:target/huntlib.git",
        "clone_url": "https://github.com/target/huntlib.git",
        "svn_url": "https://github.com/target/huntlib",
        "homepage": "",
        "size": 51,
        "stargazers_count": 19,
        "watchers_count": 19,
        "language": "Python",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 2,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [
            "cfc",
            "hunt",
            "security",
            "target-cfc"
        ],
        "forks": 2,
        "open_issues": 0,
        "watchers": 19,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 148205004,
        "node_id": "MDEwOlJlcG9zaXRvcnkxNDgyMDUwMDQ=",
        "name": "matrixprofile-ts",
        "full_name": "target/matrixprofile-ts",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/matrixprofile-ts",
        "description": "An open source Python time series library for motif discovery and anomaly detection using Matrix Profile",
        "fork": false,
        "url": "https://api.github.com/repos/target/matrixprofile-ts",
        "forks_url": "https://api.github.com/repos/target/matrixprofile-ts/forks",
        "keys_url": "https://api.github.com/repos/target/matrixprofile-ts/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/matrixprofile-ts/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/matrixprofile-ts/teams",
        "hooks_url": "https://api.github.com/repos/target/matrixprofile-ts/hooks",
        "issue_events_url": "https://api.github.com/repos/target/matrixprofile-ts/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/matrixprofile-ts/events",
        "assignees_url": "https://api.github.com/repos/target/matrixprofile-ts/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/matrixprofile-ts/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/matrixprofile-ts/tags",
        "blobs_url": "https://api.github.com/repos/target/matrixprofile-ts/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/matrixprofile-ts/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/matrixprofile-ts/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/matrixprofile-ts/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/matrixprofile-ts/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/matrixprofile-ts/languages",
        "stargazers_url": "https://api.github.com/repos/target/matrixprofile-ts/stargazers",
        "contributors_url": "https://api.github.com/repos/target/matrixprofile-ts/contributors",
        "subscribers_url": "https://api.github.com/repos/target/matrixprofile-ts/subscribers",
        "subscription_url": "https://api.github.com/repos/target/matrixprofile-ts/subscription",
        "commits_url": "https://api.github.com/repos/target/matrixprofile-ts/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/matrixprofile-ts/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/matrixprofile-ts/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/matrixprofile-ts/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/matrixprofile-ts/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/matrixprofile-ts/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/matrixprofile-ts/merges",
        "archive_url": "https://api.github.com/repos/target/matrixprofile-ts/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/matrixprofile-ts/downloads",
        "issues_url": "https://api.github.com/repos/target/matrixprofile-ts/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/matrixprofile-ts/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/matrixprofile-ts/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/matrixprofile-ts/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/matrixprofile-ts/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/matrixprofile-ts/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/matrixprofile-ts/deployments",
        "created_at": "2018-09-10T19:03:34Z",
        "updated_at": "2018-12-28T17:32:22Z",
        "pushed_at": "2018-12-28T17:32:21Z",
        "git_url": "git://github.com/target/matrixprofile-ts.git",
        "ssh_url": "git@github.com:target/matrixprofile-ts.git",
        "clone_url": "https://github.com/target/matrixprofile-ts.git",
        "svn_url": "https://github.com/target/matrixprofile-ts",
        "homepage": "https://pypi.org/project/matrixprofile-ts/",
        "size": 1176,
        "stargazers_count": 55,
        "watchers_count": 55,
        "language": "Python",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 11,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 4,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [
            "data-science",
            "matrix-profile",
            "motif",
            "motif-discovery",
            "pip",
            "pip3",
            "pypi",
            "pypi-packages",
            "python",
            "python3",
            "time-series"
        ],
        "forks": 11,
        "open_issues": 4,
        "watchers": 55,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 149298900,
        "node_id": "MDEwOlJlcG9zaXRvcnkxNDkyOTg5MDA=",
        "name": "edge-mac-integrations",
        "full_name": "target/edge-mac-integrations",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/edge-mac-integrations",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/target/edge-mac-integrations",
        "forks_url": "https://api.github.com/repos/target/edge-mac-integrations/forks",
        "keys_url": "https://api.github.com/repos/target/edge-mac-integrations/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/edge-mac-integrations/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/edge-mac-integrations/teams",
        "hooks_url": "https://api.github.com/repos/target/edge-mac-integrations/hooks",
        "issue_events_url": "https://api.github.com/repos/target/edge-mac-integrations/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/edge-mac-integrations/events",
        "assignees_url": "https://api.github.com/repos/target/edge-mac-integrations/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/edge-mac-integrations/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/edge-mac-integrations/tags",
        "blobs_url": "https://api.github.com/repos/target/edge-mac-integrations/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/edge-mac-integrations/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/edge-mac-integrations/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/edge-mac-integrations/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/edge-mac-integrations/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/edge-mac-integrations/languages",
        "stargazers_url": "https://api.github.com/repos/target/edge-mac-integrations/stargazers",
        "contributors_url": "https://api.github.com/repos/target/edge-mac-integrations/contributors",
        "subscribers_url": "https://api.github.com/repos/target/edge-mac-integrations/subscribers",
        "subscription_url": "https://api.github.com/repos/target/edge-mac-integrations/subscription",
        "commits_url": "https://api.github.com/repos/target/edge-mac-integrations/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/edge-mac-integrations/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/edge-mac-integrations/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/edge-mac-integrations/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/edge-mac-integrations/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/edge-mac-integrations/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/edge-mac-integrations/merges",
        "archive_url": "https://api.github.com/repos/target/edge-mac-integrations/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/edge-mac-integrations/downloads",
        "issues_url": "https://api.github.com/repos/target/edge-mac-integrations/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/edge-mac-integrations/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/edge-mac-integrations/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/edge-mac-integrations/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/edge-mac-integrations/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/edge-mac-integrations/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/edge-mac-integrations/deployments",
        "created_at": "2018-09-18T14:08:00Z",
        "updated_at": "2018-12-04T21:03:43Z",
        "pushed_at": "2018-11-07T17:23:45Z",
        "git_url": "git://github.com/target/edge-mac-integrations.git",
        "ssh_url": "git@github.com:target/edge-mac-integrations.git",
        "clone_url": "https://github.com/target/edge-mac-integrations.git",
        "svn_url": "https://github.com/target/edge-mac-integrations",
        "homepage": null,
        "size": 48517,
        "stargazers_count": 10,
        "watchers_count": 10,
        "language": "Shell",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 2,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [],
        "forks": 2,
        "open_issues": 0,
        "watchers": 10,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 149654117,
        "node_id": "MDEwOlJlcG9zaXRvcnkxNDk2NTQxMTc=",
        "name": "strelka",
        "full_name": "target/strelka",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/strelka",
        "description": "Scanning files at scale with Python and ZeroMQ",
        "fork": false,
        "url": "https://api.github.com/repos/target/strelka",
        "forks_url": "https://api.github.com/repos/target/strelka/forks",
        "keys_url": "https://api.github.com/repos/target/strelka/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/strelka/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/strelka/teams",
        "hooks_url": "https://api.github.com/repos/target/strelka/hooks",
        "issue_events_url": "https://api.github.com/repos/target/strelka/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/strelka/events",
        "assignees_url": "https://api.github.com/repos/target/strelka/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/strelka/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/strelka/tags",
        "blobs_url": "https://api.github.com/repos/target/strelka/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/strelka/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/strelka/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/strelka/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/strelka/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/strelka/languages",
        "stargazers_url": "https://api.github.com/repos/target/strelka/stargazers",
        "contributors_url": "https://api.github.com/repos/target/strelka/contributors",
        "subscribers_url": "https://api.github.com/repos/target/strelka/subscribers",
        "subscription_url": "https://api.github.com/repos/target/strelka/subscription",
        "commits_url": "https://api.github.com/repos/target/strelka/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/strelka/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/strelka/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/strelka/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/strelka/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/strelka/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/strelka/merges",
        "archive_url": "https://api.github.com/repos/target/strelka/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/strelka/downloads",
        "issues_url": "https://api.github.com/repos/target/strelka/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/strelka/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/strelka/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/strelka/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/strelka/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/strelka/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/strelka/deployments",
        "created_at": "2018-09-20T18:38:12Z",
        "updated_at": "2018-12-28T16:53:41Z",
        "pushed_at": "2018-12-12T17:24:19Z",
        "git_url": "git://github.com/target/strelka.git",
        "ssh_url": "git@github.com:target/strelka.git",
        "clone_url": "https://github.com/target/strelka.git",
        "svn_url": "https://github.com/target/strelka",
        "homepage": "",
        "size": 166,
        "stargazers_count": 176,
        "watchers_count": 176,
        "language": "Python",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 17,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 7,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [
            "cfc",
            "detection",
            "python3",
            "security",
            "target-cfc"
        ],
        "forks": 17,
        "open_issues": 7,
        "watchers": 176,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 150125559,
        "node_id": "MDEwOlJlcG9zaXRvcnkxNTAxMjU1NTk=",
        "name": "attack-navigator-docker",
        "full_name": "target/attack-navigator-docker",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/attack-navigator-docker",
        "description": "A simple Docker container that serves the MITRE ATT&CK Navigator web app",
        "fork": false,
        "url": "https://api.github.com/repos/target/attack-navigator-docker",
        "forks_url": "https://api.github.com/repos/target/attack-navigator-docker/forks",
        "keys_url": "https://api.github.com/repos/target/attack-navigator-docker/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/attack-navigator-docker/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/attack-navigator-docker/teams",
        "hooks_url": "https://api.github.com/repos/target/attack-navigator-docker/hooks",
        "issue_events_url": "https://api.github.com/repos/target/attack-navigator-docker/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/attack-navigator-docker/events",
        "assignees_url": "https://api.github.com/repos/target/attack-navigator-docker/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/attack-navigator-docker/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/attack-navigator-docker/tags",
        "blobs_url": "https://api.github.com/repos/target/attack-navigator-docker/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/attack-navigator-docker/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/attack-navigator-docker/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/attack-navigator-docker/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/attack-navigator-docker/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/attack-navigator-docker/languages",
        "stargazers_url": "https://api.github.com/repos/target/attack-navigator-docker/stargazers",
        "contributors_url": "https://api.github.com/repos/target/attack-navigator-docker/contributors",
        "subscribers_url": "https://api.github.com/repos/target/attack-navigator-docker/subscribers",
        "subscription_url": "https://api.github.com/repos/target/attack-navigator-docker/subscription",
        "commits_url": "https://api.github.com/repos/target/attack-navigator-docker/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/attack-navigator-docker/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/attack-navigator-docker/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/attack-navigator-docker/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/attack-navigator-docker/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/attack-navigator-docker/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/attack-navigator-docker/merges",
        "archive_url": "https://api.github.com/repos/target/attack-navigator-docker/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/attack-navigator-docker/downloads",
        "issues_url": "https://api.github.com/repos/target/attack-navigator-docker/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/attack-navigator-docker/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/attack-navigator-docker/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/attack-navigator-docker/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/attack-navigator-docker/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/attack-navigator-docker/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/attack-navigator-docker/deployments",
        "created_at": "2018-09-24T15:32:40Z",
        "updated_at": "2018-12-21T05:12:01Z",
        "pushed_at": "2018-12-21T05:11:59Z",
        "git_url": "git://github.com/target/attack-navigator-docker.git",
        "ssh_url": "git@github.com:target/attack-navigator-docker.git",
        "clone_url": "https://github.com/target/attack-navigator-docker.git",
        "svn_url": "https://github.com/target/attack-navigator-docker",
        "homepage": "",
        "size": 17,
        "stargazers_count": 7,
        "watchers_count": 7,
        "language": "Makefile",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [
            "cfc",
            "detection",
            "security",
            "target-cfc"
        ],
        "forks": 0,
        "open_issues": 0,
        "watchers": 7,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 150317781,
        "node_id": "MDEwOlJlcG9zaXRvcnkxNTAzMTc3ODE=",
        "name": "impeller",
        "full_name": "target/impeller",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/impeller",
        "description": "Manage Helm charts in Kubernetes clusters.",
        "fork": false,
        "url": "https://api.github.com/repos/target/impeller",
        "forks_url": "https://api.github.com/repos/target/impeller/forks",
        "keys_url": "https://api.github.com/repos/target/impeller/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/impeller/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/impeller/teams",
        "hooks_url": "https://api.github.com/repos/target/impeller/hooks",
        "issue_events_url": "https://api.github.com/repos/target/impeller/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/impeller/events",
        "assignees_url": "https://api.github.com/repos/target/impeller/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/impeller/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/impeller/tags",
        "blobs_url": "https://api.github.com/repos/target/impeller/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/impeller/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/impeller/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/impeller/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/impeller/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/impeller/languages",
        "stargazers_url": "https://api.github.com/repos/target/impeller/stargazers",
        "contributors_url": "https://api.github.com/repos/target/impeller/contributors",
        "subscribers_url": "https://api.github.com/repos/target/impeller/subscribers",
        "subscription_url": "https://api.github.com/repos/target/impeller/subscription",
        "commits_url": "https://api.github.com/repos/target/impeller/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/impeller/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/impeller/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/impeller/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/impeller/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/impeller/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/impeller/merges",
        "archive_url": "https://api.github.com/repos/target/impeller/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/impeller/downloads",
        "issues_url": "https://api.github.com/repos/target/impeller/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/impeller/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/impeller/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/impeller/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/impeller/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/impeller/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/impeller/deployments",
        "created_at": "2018-09-25T19:21:48Z",
        "updated_at": "2018-11-01T00:48:18Z",
        "pushed_at": "2018-10-17T02:12:00Z",
        "git_url": "git://github.com/target/impeller.git",
        "ssh_url": "git@github.com:target/impeller.git",
        "clone_url": "https://github.com/target/impeller.git",
        "svn_url": "https://github.com/target/impeller",
        "homepage": "",
        "size": 15,
        "stargazers_count": 5,
        "watchers_count": 5,
        "language": "Go",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "mit",
            "name": "MIT License",
            "spdx_id": "MIT",
            "url": "https://api.github.com/licenses/mit",
            "node_id": "MDc6TGljZW5zZTEz"
        },
        "topics": [
            "helm",
            "kubernetes"
        ],
        "forks": 0,
        "open_issues": 0,
        "watchers": 5,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    },
    {
        "id": 153648715,
        "node_id": "MDEwOlJlcG9zaXRvcnkxNTM2NDg3MTU=",
        "name": "Schema-Check-filter-for-Logstash",
        "full_name": "target/Schema-Check-filter-for-Logstash",
        "private": false,
        "owner": {
            "login": "target",
            "id": 932489,
            "node_id": "MDEyOk9yZ2FuaXphdGlvbjkzMjQ4OQ==",
            "avatar_url": "https://avatars2.githubusercontent.com/u/932489?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/target",
            "html_url": "https://github.com/target",
            "followers_url": "https://api.github.com/users/target/followers",
            "following_url": "https://api.github.com/users/target/following{/other_user}",
            "gists_url": "https://api.github.com/users/target/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/target/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/target/subscriptions",
            "organizations_url": "https://api.github.com/users/target/orgs",
            "repos_url": "https://api.github.com/users/target/repos",
            "events_url": "https://api.github.com/users/target/events{/privacy}",
            "received_events_url": "https://api.github.com/users/target/received_events",
            "type": "Organization",
            "site_admin": false
        },
        "html_url": "https://github.com/target/Schema-Check-filter-for-Logstash",
        "description": "Schema Check filter for Logstash",
        "fork": false,
        "url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash",
        "forks_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/forks",
        "keys_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/teams",
        "hooks_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/hooks",
        "issue_events_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/issues/events{/number}",
        "events_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/events",
        "assignees_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/assignees{/user}",
        "branches_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/branches{/branch}",
        "tags_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/tags",
        "blobs_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/languages",
        "stargazers_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/stargazers",
        "contributors_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/contributors",
        "subscribers_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/subscribers",
        "subscription_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/subscription",
        "commits_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/contents/{+path}",
        "compare_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/merges",
        "archive_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/downloads",
        "issues_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/issues{/number}",
        "pulls_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/labels{/name}",
        "releases_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/releases{/id}",
        "deployments_url": "https://api.github.com/repos/target/Schema-Check-filter-for-Logstash/deployments",
        "created_at": "2018-10-18T15:44:20Z",
        "updated_at": "2018-10-29T13:57:12Z",
        "pushed_at": "2018-10-24T01:23:39Z",
        "git_url": "git://github.com/target/Schema-Check-filter-for-Logstash.git",
        "ssh_url": "git@github.com:target/Schema-Check-filter-for-Logstash.git",
        "clone_url": "https://github.com/target/Schema-Check-filter-for-Logstash.git",
        "svn_url": "https://github.com/target/Schema-Check-filter-for-Logstash",
        "homepage": null,
        "size": 8,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Ruby",
        "has_issues": true,
        "has_projects": false,
        "has_downloads": true,
        "has_wiki": false,
        "has_pages": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "open_issues_count": 0,
        "license": {
            "key": "other",
            "name": "Other",
            "spdx_id": "NOASSERTION",
            "url": null,
            "node_id": "MDc6TGljZW5zZTA="
        },
        "topics": [
            "cfc",
            "data",
            "target-cfc"
        ],
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master",
        "permissions": {
            "admin": false,
            "push": false,
            "pull": true
        }
    }
]
